{
  "v": "5.5.5",
  "fr": 25,
  "ip": 298,
  "op": 333,
  "w": 2000,
  "h": 2000,
  "nm": "\rJSON",
  "ddd": 0,
  "assets": [
    {
      "id": "comp_0",
      "layers": [
        {
          "ddd": 0,
          "ind": 1,
          "ty": 4,
          "nm": "Shape Layer 2",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [996, 1000, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [197, -440],
                        [358, -440]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tm",
                  "s": {
                    "a": 1,
                    "k": [
                      { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.701], "y": [0] }, "t": 258, "s": [0] },
                      { "t": 280, "s": [100] }
                    ],
                    "ix": 1
                  },
                  "e": {
                    "a": 1,
                    "k": [
                      { "i": { "x": [0.36], "y": [1] }, "o": { "x": [0.522], "y": [0] }, "t": 258, "s": [0] },
                      { "t": 280, "s": [100] }
                    ],
                    "ix": 2
                  },
                  "o": { "a": 0, "k": 0, "ix": 3 },
                  "m": 1,
                  "ix": 2,
                  "nm": "Trim Paths 1",
                  "mn": "ADBE Vector Filter - Trim",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3, "ix": 5 },
                  "lc": 2,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, -4], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Shape 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 258,
          "op": 280,
          "st": 92,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 2,
          "ty": 4,
          "nm": "Shape Layer 1",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [996, 1000, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [197, -440],
                        [358, -440]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tm",
                  "s": {
                    "a": 1,
                    "k": [
                      { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.701], "y": [0] }, "t": 180, "s": [0] },
                      { "t": 202, "s": [100] }
                    ],
                    "ix": 1
                  },
                  "e": {
                    "a": 1,
                    "k": [
                      { "i": { "x": [0.36], "y": [1] }, "o": { "x": [0.522], "y": [0] }, "t": 180, "s": [0] },
                      { "t": 202, "s": [100] }
                    ],
                    "ix": 2
                  },
                  "o": { "a": 0, "k": 0, "ix": 3 },
                  "m": 1,
                  "ix": 2,
                  "nm": "Trim Paths 1",
                  "mn": "ADBE Vector Filter - Trim",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3, "ix": 5 },
                  "lc": 2,
                  "lj": 1,
                  "ml": 4,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, -4], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Shape 1",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 180,
          "op": 202,
          "st": 14,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 3,
          "ty": 3,
          "nm": "NULL CONTROL",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 0, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [1206.228, 516.038, 0], "ix": 2 },
            "a": { "a": 0, "k": [60, 60, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 394,
          "op": 894,
          "st": 394,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 4,
          "ty": 4,
          "nm": "\rV",
          "parent": 3,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": -1.1, "ix": 10 },
            "p": { "a": 0, "k": [53.949, 96.775, 0], "ix": 2 },
            "a": { "a": 0, "k": [364.501, -502.674, 0], "ix": 1 },
            "s": { "a": 0, "k": [75, 75, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [315.479, -556.604],
                        [365.779, -501.34],
                        [440.19, -576.332]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 19.244, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tm",
              "s": { "a": 0, "k": 0, "ix": 1 },
              "e": {
                "a": 1,
                "k": [
                  { "i": { "x": [0.005], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 408, "s": [0] },
                  { "t": 424, "s": [100] }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "m": 1,
              "ix": 2,
              "nm": "Trim Paths 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }
          ],
          "ip": 408,
          "op": 908,
          "st": 408,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 5,
          "ty": 4,
          "nm": "\rcenter",
          "parent": 3,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [60, 60, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.17, 0.17, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.426, 0.426, 0.333], "y": [0, 0, 0] },
                  "t": 394,
                  "s": [0, 0, 100]
                },
                { "t": 414, "s": [75, 75, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [213.382, 213.382], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.164705887437, 0.749019622803, 0.156862750649, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 394,
          "op": 894,
          "st": 394,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 6,
          "ty": 4,
          "nm": "\routline",
          "parent": 3,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 80, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [60, 60, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.33, 0.33, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 416,
                  "s": [60, 60, 100]
                },
                { "t": 436, "s": [75, 75, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [254.566, 254.566], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.164705887437, 0.749019622803, 0.156862750649, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": [0.833], "y": [0.833] },
                        "o": { "x": [0.167], "y": [0.167] },
                        "t": 416,
                        "s": [12.352]
                      },
                      { "t": 436, "s": [0] }
                    ],
                    "ix": 5
                  },
                  "lc": 1,
                  "lj": 1,
                  "ml": 10,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 416,
          "op": 437,
          "st": 416,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 7,
          "ty": 3,
          "nm": "NULL CONTROL",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 0, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [1206.228, 516.038, 0], "ix": 2 },
            "a": { "a": 0, "k": [60, 60, 0], "ix": 1 },
            "s": { "a": 0, "k": [75, 75, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 298,
          "op": 735,
          "st": -18,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 8,
          "ty": 4,
          "nm": "\rloader circle 3",
          "parent": 7,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [60, 60, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [208.433, 208.433], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.262745098039, 0.658823529412, 0.780392156863, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 30, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tm",
              "s": {
                "a": 1,
                "k": [
                  { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.726], "y": [0] }, "t": 360, "s": [0] },
                  { "t": 402, "s": [100] }
                ],
                "ix": 1
              },
              "e": {
                "a": 1,
                "k": [
                  { "i": { "x": [0.264], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 360, "s": [25] },
                  { "t": 392, "s": [100] }
                ],
                "ix": 2
              },
              "o": {
                "a": 1,
                "k": [
                  { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 360, "s": [-90] },
                  { "t": 401, "s": [0] }
                ],
                "ix": 3
              },
              "m": 1,
              "ix": 2,
              "nm": "Trim Paths 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }
          ],
          "ip": 360,
          "op": 735,
          "st": 360,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 9,
          "ty": 4,
          "nm": "\rloader circle 2",
          "parent": 7,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [60, 60, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [208.433, 208.433], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.262745098039, 0.658823529412, 0.780392156863, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 30, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tm",
              "s": {
                "a": 1,
                "k": [
                  { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.726], "y": [0] }, "t": 327, "s": [0] },
                  { "t": 359, "s": [75] }
                ],
                "ix": 1
              },
              "e": {
                "a": 1,
                "k": [
                  { "i": { "x": [0.264], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 327, "s": [25] },
                  { "t": 359, "s": [100] }
                ],
                "ix": 2
              },
              "o": {
                "a": 1,
                "k": [
                  { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 327, "s": [-90] },
                  { "t": 359, "s": [0] }
                ],
                "ix": 3
              },
              "m": 1,
              "ix": 2,
              "nm": "Trim Paths 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }
          ],
          "ip": 327,
          "op": 360,
          "st": 327,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 10,
          "ty": 4,
          "nm": "\rloader circle",
          "parent": 7,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [60, 60, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [208.433, 208.433], "ix": 2 },
                  "p": { "a": 0, "k": [0, 0], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.262745098039, 0.658823529412, 0.780392156863, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 30, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tm",
              "s": {
                "a": 1,
                "k": [
                  { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.726], "y": [0] }, "t": 298, "s": [0] },
                  { "t": 330, "s": [75] }
                ],
                "ix": 1
              },
              "e": {
                "a": 1,
                "k": [
                  { "i": { "x": [0.264], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 298, "s": [0] },
                  { "t": 330, "s": [100] }
                ],
                "ix": 2
              },
              "o": { "a": 0, "k": 0, "ix": 3 },
              "m": 1,
              "ix": 2,
              "nm": "Trim Paths 1",
              "mn": "ADBE Vector Filter - Trim",
              "hd": false
            }
          ],
          "ip": 298,
          "op": 327,
          "st": 298,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 11,
          "ty": 4,
          "nm": "bubble 3",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [1206.228, 516.038, 0], "ix": 2 },
            "a": { "a": 0, "k": [348.9, -558.815, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.273, 0.273, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 1,
                  "s": [0, 0, 100]
                },
                { "t": 20, "s": [75, 75, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [527.757, 527.757], "ix": 2 },
                  "p": { "a": 0, "k": [348.9, -558.815], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 23,
          "op": 504,
          "st": 1,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 12,
          "ty": 3,
          "nm": "NULL CONTROL 2",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 0, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.638, "y": 1 },
                  "o": { "x": 0.974, "y": 0 },
                  "t": 281,
                  "s": [1206.4, 516, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 301, "s": [1206.4, 232, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [60, 60, 0], "ix": 1 },
            "s": { "a": 0, "k": [75.8, 75.8, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 220,
          "op": 297,
          "st": 220,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 13,
          "ty": 4,
          "nm": "number - Group 20",
          "parent": 12,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 254, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 258, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 294, "s": [100] },
                { "t": 303, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 253,
                  "s": [396.475, 60.72, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 266, "s": [239.475, 60.72, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [179.475, 0.72, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.096, 1.696],
                        [0, 0],
                        [0.561, -0.111],
                        [0.496, 0.096],
                        [0.383, 0.24],
                        [0.191, 0.288],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -1.599],
                        [0, 0],
                        [-0.574, 0.448],
                        [-0.561, 0.113],
                        [-0.496, -0.096],
                        [-0.385, -0.24],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [201.164, 26.585],
                        [201.164, 35.462],
                        [162.775, 35.462],
                        [162.775, 26.585],
                        [176.836, 26.585],
                        [176.836, -13.867],
                        [176.98, -18.81],
                        [166.998, -10.46],
                        [165.295, -9.621],
                        [163.711, -9.596],
                        [162.393, -10.1],
                        [161.529, -10.892],
                        [157.785, -16.026],
                        [178.947, -34.021],
                        [188.688, -34.021],
                        [188.688, 26.585]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }
          ],
          "ip": 276,
          "op": 281,
          "st": 253,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 14,
          "ty": 4,
          "nm": "number - Group 19",
          "parent": 12,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 247, "s": [0] },
                { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 251, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 276, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 277, "s": [0] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 280, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 281, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 292, "s": [100] },
                { "t": 301, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 246,
                  "s": [396.475, 60.72, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 259, "s": [239.475, 60.72, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [179.475, 0.72, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.096, 1.696],
                        [0, 0],
                        [0.561, -0.111],
                        [0.496, 0.096],
                        [0.383, 0.24],
                        [0.191, 0.288],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -1.599],
                        [0, 0],
                        [-0.574, 0.448],
                        [-0.561, 0.113],
                        [-0.496, -0.096],
                        [-0.385, -0.24],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [201.164, 26.585],
                        [201.164, 35.462],
                        [162.775, 35.462],
                        [162.775, 26.585],
                        [176.836, 26.585],
                        [176.836, -13.867],
                        [176.98, -18.81],
                        [166.998, -10.46],
                        [165.295, -9.621],
                        [163.711, -9.596],
                        [162.393, -10.1],
                        [161.529, -10.892],
                        [157.785, -16.026],
                        [178.947, -34.021],
                        [188.688, -34.021],
                        [188.688, 26.585]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 246,
          "op": 307,
          "st": 246,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 15,
          "ty": 4,
          "nm": "number - Group 18",
          "parent": 12,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 252, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 256, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 294, "s": [100] },
                { "t": 303, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 251,
                  "s": [340.669, 60.768, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 264, "s": [183.669, 60.768, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [123.669, 0.768, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 5.022],
                        [0.734, 3.295],
                        [1.23, 1.952],
                        [1.6, 0.784],
                        [1.729, 0],
                        [1.584, -0.784],
                        [1.217, -1.951],
                        [0.719, -3.295],
                        [0, -5.022],
                        [-0.721, -3.295],
                        [-1.215, -1.95],
                        [-1.584, -0.783],
                        [-1.695, 0],
                        [-1.6, 0.785],
                        [-1.232, 1.952],
                        [-0.736, 3.295]
                      ],
                      "o": [
                        [0, -5.022],
                        [-0.736, -3.295],
                        [-1.232, -1.951],
                        [-1.6, -0.784],
                        [-1.695, 0],
                        [-1.584, 0.784],
                        [-1.215, 1.952],
                        [-0.721, 3.295],
                        [0, 5.022],
                        [0.719, 3.295],
                        [1.217, 1.952],
                        [1.584, 0.785],
                        [1.729, 0],
                        [1.6, -0.783],
                        [1.23, -1.95],
                        [0.734, -3.295]
                      ],
                      "v": [
                        [136.865, 0.769],
                        [135.762, -11.708],
                        [132.811, -19.577],
                        [128.562, -23.68],
                        [123.572, -24.856],
                        [118.654, -23.68],
                        [114.455, -19.577],
                        [111.553, -11.708],
                        [110.473, 0.769],
                        [111.553, 13.245],
                        [114.455, 21.114],
                        [118.654, 25.217],
                        [123.572, 26.393],
                        [128.562, 25.217],
                        [132.811, 21.114],
                        [135.762, 13.245]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, -6.078],
                        [1.295, -4.463],
                        [2.287, -2.911],
                        [3.119, -1.423],
                        [3.615, 0],
                        [3.088, 1.423],
                        [2.271, 2.911],
                        [1.279, 4.462],
                        [0, 6.046],
                        [-1.279, 4.447],
                        [-2.271, 2.911],
                        [-3.088, 1.424],
                        [-3.615, 0],
                        [-3.119, -1.423],
                        [-2.287, -2.911],
                        [-1.297, -4.446]
                      ],
                      "o": [
                        [0, 6.046],
                        [-1.297, 4.462],
                        [-2.287, 2.911],
                        [-3.119, 1.423],
                        [-3.615, 0],
                        [-3.088, -1.423],
                        [-2.271, -2.911],
                        [-1.279, -4.463],
                        [0, -6.078],
                        [1.279, -4.446],
                        [2.271, -2.911],
                        [3.088, -1.423],
                        [3.615, 0],
                        [3.119, 1.424],
                        [2.287, 2.911],
                        [1.295, 4.447]
                      ],
                      "v": [
                        [149.102, 0.769],
                        [147.158, 16.532],
                        [141.783, 27.593],
                        [133.674, 34.095],
                        [123.572, 36.229],
                        [113.52, 34.095],
                        [105.482, 27.593],
                        [100.156, 16.532],
                        [98.236, 0.769],
                        [100.156, -15.019],
                        [105.482, -26.055],
                        [113.52, -32.558],
                        [123.572, -34.693],
                        [133.674, -32.558],
                        [141.783, -26.055],
                        [147.158, -15.019]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }
          ],
          "ip": 271,
          "op": 276,
          "st": 251,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 16,
          "ty": 4,
          "nm": "number - Group 17",
          "parent": 12,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 245, "s": [0] },
                { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 249, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 271, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 272, "s": [0] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 275, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 276, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 292, "s": [100] },
                { "t": 301, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 244,
                  "s": [340.669, 60.768, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 257, "s": [183.669, 60.768, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [123.669, 0.768, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 5.022],
                        [0.734, 3.295],
                        [1.23, 1.952],
                        [1.6, 0.784],
                        [1.729, 0],
                        [1.584, -0.784],
                        [1.217, -1.951],
                        [0.719, -3.295],
                        [0, -5.022],
                        [-0.721, -3.295],
                        [-1.215, -1.95],
                        [-1.584, -0.783],
                        [-1.695, 0],
                        [-1.6, 0.785],
                        [-1.232, 1.952],
                        [-0.736, 3.295]
                      ],
                      "o": [
                        [0, -5.022],
                        [-0.736, -3.295],
                        [-1.232, -1.951],
                        [-1.6, -0.784],
                        [-1.695, 0],
                        [-1.584, 0.784],
                        [-1.215, 1.952],
                        [-0.721, 3.295],
                        [0, 5.022],
                        [0.719, 3.295],
                        [1.217, 1.952],
                        [1.584, 0.785],
                        [1.729, 0],
                        [1.6, -0.783],
                        [1.23, -1.95],
                        [0.734, -3.295]
                      ],
                      "v": [
                        [136.865, 0.769],
                        [135.762, -11.708],
                        [132.811, -19.577],
                        [128.562, -23.68],
                        [123.572, -24.856],
                        [118.654, -23.68],
                        [114.455, -19.577],
                        [111.553, -11.708],
                        [110.473, 0.769],
                        [111.553, 13.245],
                        [114.455, 21.114],
                        [118.654, 25.217],
                        [123.572, 26.393],
                        [128.562, 25.217],
                        [132.811, 21.114],
                        [135.762, 13.245]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, -6.078],
                        [1.295, -4.463],
                        [2.287, -2.911],
                        [3.119, -1.423],
                        [3.615, 0],
                        [3.088, 1.423],
                        [2.271, 2.911],
                        [1.279, 4.462],
                        [0, 6.046],
                        [-1.279, 4.447],
                        [-2.271, 2.911],
                        [-3.088, 1.424],
                        [-3.615, 0],
                        [-3.119, -1.423],
                        [-2.287, -2.911],
                        [-1.297, -4.446]
                      ],
                      "o": [
                        [0, 6.046],
                        [-1.297, 4.462],
                        [-2.287, 2.911],
                        [-3.119, 1.423],
                        [-3.615, 0],
                        [-3.088, -1.423],
                        [-2.271, -2.911],
                        [-1.279, -4.463],
                        [0, -6.078],
                        [1.279, -4.446],
                        [2.271, -2.911],
                        [3.088, -1.423],
                        [3.615, 0],
                        [3.119, 1.424],
                        [2.287, 2.911],
                        [1.295, 4.447]
                      ],
                      "v": [
                        [149.102, 0.769],
                        [147.158, 16.532],
                        [141.783, 27.593],
                        [133.674, 34.095],
                        [123.572, 36.229],
                        [113.52, 34.095],
                        [105.482, 27.593],
                        [100.156, 16.532],
                        [98.236, 0.769],
                        [100.156, -15.019],
                        [105.482, -26.055],
                        [113.52, -32.558],
                        [123.572, -34.693],
                        [133.674, -32.558],
                        [141.783, -26.055],
                        [147.158, -15.019]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 244,
          "op": 307,
          "st": 244,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 17,
          "ty": 4,
          "nm": "number - Group 16",
          "parent": 12,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 250, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 254, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 294, "s": [100] },
                { "t": 303, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 249,
                  "s": [285.008, 60.768, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 262, "s": [128.008, 60.768, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [68.008, 0.768, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 5.022],
                        [0.736, 3.295],
                        [1.232, 1.952],
                        [1.6, 0.784],
                        [1.727, 0],
                        [1.582, -0.784],
                        [1.215, -1.951],
                        [0.721, -3.295],
                        [0, -5.022],
                        [-0.719, -3.295],
                        [-1.217, -1.95],
                        [-1.584, -0.783],
                        [-1.695, 0],
                        [-1.6, 0.785],
                        [-1.23, 1.952],
                        [-0.736, 3.295]
                      ],
                      "o": [
                        [0, -5.022],
                        [-0.736, -3.295],
                        [-1.23, -1.951],
                        [-1.6, -0.784],
                        [-1.695, 0],
                        [-1.584, 0.784],
                        [-1.217, 1.952],
                        [-0.719, 3.295],
                        [0, 5.022],
                        [0.721, 3.295],
                        [1.215, 1.952],
                        [1.582, 0.785],
                        [1.727, 0],
                        [1.6, -0.783],
                        [1.232, -1.95],
                        [0.736, -3.295]
                      ],
                      "v": [
                        [81.203, 0.769],
                        [80.1, -11.708],
                        [77.148, -19.577],
                        [72.902, -23.68],
                        [67.912, -24.856],
                        [62.994, -23.68],
                        [58.795, -19.577],
                        [55.891, -11.708],
                        [54.812, 0.769],
                        [55.891, 13.245],
                        [58.795, 21.114],
                        [62.994, 25.217],
                        [67.912, 26.393],
                        [72.902, 25.217],
                        [77.148, 21.114],
                        [80.1, 13.245]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, -6.078],
                        [1.297, -4.463],
                        [2.285, -2.911],
                        [3.117, -1.423],
                        [3.615, 0],
                        [3.086, 1.423],
                        [2.27, 2.911],
                        [1.279, 4.462],
                        [0, 6.046],
                        [-1.279, 4.447],
                        [-2.273, 2.911],
                        [-3.088, 1.424],
                        [-3.615, 0],
                        [-3.119, -1.423],
                        [-2.289, -2.911],
                        [-1.295, -4.446]
                      ],
                      "o": [
                        [0, 6.046],
                        [-1.295, 4.462],
                        [-2.289, 2.911],
                        [-3.119, 1.423],
                        [-3.615, 0],
                        [-3.088, -1.423],
                        [-2.273, -2.911],
                        [-1.279, -4.463],
                        [0, -6.078],
                        [1.279, -4.446],
                        [2.27, -2.911],
                        [3.086, -1.423],
                        [3.615, 0],
                        [3.117, 1.424],
                        [2.285, 2.911],
                        [1.297, 4.447]
                      ],
                      "v": [
                        [93.439, 0.769],
                        [91.496, 16.532],
                        [86.123, 27.593],
                        [78.014, 34.095],
                        [67.912, 36.229],
                        [57.859, 34.095],
                        [49.822, 27.593],
                        [44.494, 16.532],
                        [42.576, 0.769],
                        [44.494, -15.019],
                        [49.822, -26.055],
                        [57.859, -32.558],
                        [67.912, -34.693],
                        [78.014, -32.558],
                        [86.123, -26.055],
                        [91.496, -15.019]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }
          ],
          "ip": 266,
          "op": 271,
          "st": 249,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 18,
          "ty": 4,
          "nm": "number - Group 15",
          "parent": 12,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 243, "s": [0] },
                { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 247, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 266, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 267, "s": [0] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 270, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 271, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 292, "s": [100] },
                { "t": 301, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 242,
                  "s": [285.008, 60.768, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 255, "s": [128.008, 60.768, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [68.008, 0.768, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 5.022],
                        [0.736, 3.295],
                        [1.232, 1.952],
                        [1.6, 0.784],
                        [1.727, 0],
                        [1.582, -0.784],
                        [1.215, -1.951],
                        [0.721, -3.295],
                        [0, -5.022],
                        [-0.719, -3.295],
                        [-1.217, -1.95],
                        [-1.584, -0.783],
                        [-1.695, 0],
                        [-1.6, 0.785],
                        [-1.23, 1.952],
                        [-0.736, 3.295]
                      ],
                      "o": [
                        [0, -5.022],
                        [-0.736, -3.295],
                        [-1.23, -1.951],
                        [-1.6, -0.784],
                        [-1.695, 0],
                        [-1.584, 0.784],
                        [-1.217, 1.952],
                        [-0.719, 3.295],
                        [0, 5.022],
                        [0.721, 3.295],
                        [1.215, 1.952],
                        [1.582, 0.785],
                        [1.727, 0],
                        [1.6, -0.783],
                        [1.232, -1.95],
                        [0.736, -3.295]
                      ],
                      "v": [
                        [81.203, 0.769],
                        [80.1, -11.708],
                        [77.148, -19.577],
                        [72.902, -23.68],
                        [67.912, -24.856],
                        [62.994, -23.68],
                        [58.795, -19.577],
                        [55.891, -11.708],
                        [54.812, 0.769],
                        [55.891, 13.245],
                        [58.795, 21.114],
                        [62.994, 25.217],
                        [67.912, 26.393],
                        [72.902, 25.217],
                        [77.148, 21.114],
                        [80.1, 13.245]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, -6.078],
                        [1.297, -4.463],
                        [2.285, -2.911],
                        [3.117, -1.423],
                        [3.615, 0],
                        [3.086, 1.423],
                        [2.27, 2.911],
                        [1.279, 4.462],
                        [0, 6.046],
                        [-1.279, 4.447],
                        [-2.273, 2.911],
                        [-3.088, 1.424],
                        [-3.615, 0],
                        [-3.119, -1.423],
                        [-2.289, -2.911],
                        [-1.295, -4.446]
                      ],
                      "o": [
                        [0, 6.046],
                        [-1.295, 4.462],
                        [-2.289, 2.911],
                        [-3.119, 1.423],
                        [-3.615, 0],
                        [-3.088, -1.423],
                        [-2.273, -2.911],
                        [-1.279, -4.463],
                        [0, -6.078],
                        [1.279, -4.446],
                        [2.27, -2.911],
                        [3.086, -1.423],
                        [3.615, 0],
                        [3.117, 1.424],
                        [2.285, 2.911],
                        [1.297, 4.447]
                      ],
                      "v": [
                        [93.439, 0.769],
                        [91.496, 16.532],
                        [86.123, 27.593],
                        [78.014, 34.095],
                        [67.912, 36.229],
                        [57.859, 34.095],
                        [49.822, 27.593],
                        [44.494, 16.532],
                        [42.576, 0.769],
                        [44.494, -15.019],
                        [49.822, -26.055],
                        [57.859, -32.558],
                        [67.912, -34.693],
                        [78.014, -32.558],
                        [86.123, -26.055],
                        [91.496, -15.019]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 242,
          "op": 307,
          "st": 242,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 19,
          "ty": 4,
          "nm": "number - Group 14",
          "parent": 12,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 248, "s": [0] },
                { "t": 252, "s": [100] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 247,
                  "s": [229.49, 60.72, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 260, "s": [72.49, 60.72, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [12.49, 0.72, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.096, 1.696],
                        [0, 0],
                        [0.56, -0.111],
                        [0.496, 0.096],
                        [0.384, 0.24],
                        [0.191, 0.288],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -1.599],
                        [0, 0],
                        [-0.575, 0.448],
                        [-0.561, 0.113],
                        [-0.496, -0.096],
                        [-0.384, -0.24],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [34.18, 26.585],
                        [34.18, 35.462],
                        [-4.209, 35.462],
                        [-4.209, 26.585],
                        [9.85, 26.585],
                        [9.85, -13.867],
                        [9.994, -18.81],
                        [0.013, -10.46],
                        [-1.69, -9.621],
                        [-3.274, -9.596],
                        [-4.593, -10.1],
                        [-5.457, -10.892],
                        [-9.2, -16.026],
                        [11.961, -34.021],
                        [21.703, -34.021],
                        [21.703, 26.585]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }
          ],
          "ip": 261,
          "op": 266,
          "st": 247,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 20,
          "ty": 4,
          "nm": "number - Group 13",
          "parent": 12,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 241, "s": [0] },
                { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 245, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 261, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 262, "s": [0] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 265, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 266, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 292, "s": [100] },
                { "t": 301, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 240,
                  "s": [229.49, 60.72, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 253, "s": [72.49, 60.72, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [12.49, 0.72, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.096, 1.696],
                        [0, 0],
                        [0.56, -0.111],
                        [0.496, 0.096],
                        [0.384, 0.24],
                        [0.191, 0.288],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -1.599],
                        [0, 0],
                        [-0.575, 0.448],
                        [-0.561, 0.113],
                        [-0.496, -0.096],
                        [-0.384, -0.24],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [34.18, 26.585],
                        [34.18, 35.462],
                        [-4.209, 35.462],
                        [-4.209, 26.585],
                        [9.85, 26.585],
                        [9.85, -13.867],
                        [9.994, -18.81],
                        [0.013, -10.46],
                        [-1.69, -9.621],
                        [-3.274, -9.596],
                        [-4.593, -10.1],
                        [-5.457, -10.892],
                        [-9.2, -16.026],
                        [11.961, -34.021],
                        [21.703, -34.021],
                        [21.703, 26.585]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 240,
          "op": 307,
          "st": 240,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 21,
          "ty": 4,
          "nm": "icon 2",
          "parent": 22,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 292, "s": [100] },
                { "t": 301, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [-119.079, 0.044, 0], "ix": 2 },
            "a": { "a": 0, "k": [-119.079, 0.044, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.277, 0.277, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.526, 0.526, 0.333], "y": [0, 0, 0] },
                  "t": 220,
                  "s": [0, 0, 100]
                },
                { "t": 236, "s": [100, 100, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-1.009, 1.022],
                        [-6.966, 2.444],
                        [-0.294, 0.624],
                        [0.229, 0.65],
                        [0, 0],
                        [-11.674, -3.235],
                        [0, 0],
                        [-0.306, -0.623],
                        [-0.66, -0.22],
                        [-5.375, -5.306],
                        [-1.009, 1.022],
                        [0, 0],
                        [1.022, 1.009],
                        [27.203, -27.558],
                        [-1.022, -1.009],
                        [0, 0]
                      ],
                      "o": [
                        [5.306, -5.375],
                        [0.661, -0.225],
                        [0.298, -0.627],
                        [0, 0],
                        [11.635, -3.382],
                        [0, 0],
                        [-0.224, 0.656],
                        [0.306, 0.616],
                        [6.997, 2.353],
                        [1.022, 1.009],
                        [0, 0],
                        [1.009, -1.022],
                        [-27.558, -27.203],
                        [-1.009, 1.022],
                        [0, 0],
                        [1.022, 1.009]
                      ],
                      "v": [
                        [-153.938, 17.396],
                        [-135.443, 5.611],
                        [-133.958, 4.278],
                        [-133.853, 2.283],
                        [-137.004, -6.572],
                        [-101.311, -6.804],
                        [-104.335, 2.095],
                        [-104.205, 4.088],
                        [-102.699, 5.399],
                        [-84.052, 16.942],
                        [-80.374, 16.918],
                        [-69.411, 5.812],
                        [-69.435, 2.134],
                        [-168.747, 2.778],
                        [-168.723, 6.456],
                        [-157.617, 17.419]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.662745118141, 0.792156875134, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "icon",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 220,
          "op": 307,
          "st": 220,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 22,
          "ty": 4,
          "nm": "icon_BG 2",
          "parent": 12,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 292, "s": [100] },
                { "t": 301, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.199, "y": 1 },
                  "o": { "x": 0.542, "y": 0 },
                  "t": 229,
                  "s": [65.721, 60.468, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 246, "s": [-59.079, 60.468, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [-119.079, 0.468, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.413, 0.413, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.541, 0.541, 0.333], "y": [0, 0, 0] },
                  "t": 220,
                  "s": [0, 0, 100]
                },
                { "t": 233, "s": [100, 100, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [40.392, 0],
                        [0, -40.392],
                        [-40.392, 0],
                        [0, 40.392]
                      ],
                      "o": [
                        [-40.392, 0],
                        [0, 40.392],
                        [40.392, 0],
                        [0, -40.392]
                      ],
                      "v": [
                        [-119.079, -72.668],
                        [-192.215, 0.468],
                        [-119.079, 73.604],
                        [-45.943, 0.468]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.854901969433, 0.945098042488, 0.964705884457, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "icon_BG",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 220,
          "op": 307,
          "st": 220,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 23,
          "ty": 4,
          "nm": "tab 2",
          "parent": 12,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 292, "s": [100] },
                { "t": 301, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [60, 60, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.373, 0.395, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.515, 0.579, 0.333], "y": [0, 0, 0] },
                  "t": 220,
                  "s": [100, 0, 100]
                },
                { "t": 233, "s": [100, 100, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [311.389, -104.716],
                        [-293.478, -104.716],
                        [-293.478, 105.652],
                        [311.389, 105.652]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.662745118141, 0.792156875134, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "tab",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 220,
          "op": 307,
          "st": 220,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 24,
          "ty": 3,
          "nm": "NULL CONTROL",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 0, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.667, "y": 1 },
                  "o": { "x": 0.974, "y": 0 },
                  "t": 202,
                  "s": [1206.4, 516, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 217, "s": [1206.4, 232, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [60, 60, 0], "ix": 1 },
            "s": { "a": 0, "k": [75.8, 75.8, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 148,
          "op": 218,
          "st": 148,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 25,
          "ty": 4,
          "nm": "number - Group 12",
          "parent": 24,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 175, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 179, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 215, "s": [100] },
                { "t": 224, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 174,
                  "s": [396.475, 60.72, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 187, "s": [239.475, 60.72, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [179.475, 0.72, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.096, 1.696],
                        [0, 0],
                        [0.561, -0.111],
                        [0.496, 0.096],
                        [0.383, 0.24],
                        [0.191, 0.288],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -1.599],
                        [0, 0],
                        [-0.574, 0.448],
                        [-0.561, 0.113],
                        [-0.496, -0.096],
                        [-0.385, -0.24],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [201.164, 26.585],
                        [201.164, 35.462],
                        [162.775, 35.462],
                        [162.775, 26.585],
                        [176.836, 26.585],
                        [176.836, -13.867],
                        [176.98, -18.81],
                        [166.998, -10.46],
                        [165.295, -9.621],
                        [163.711, -9.596],
                        [162.393, -10.1],
                        [161.529, -10.892],
                        [157.785, -16.026],
                        [178.947, -34.021],
                        [188.688, -34.021],
                        [188.688, 26.585]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }
          ],
          "ip": 197,
          "op": 202,
          "st": 174,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 26,
          "ty": 4,
          "nm": "number - Group 1",
          "parent": 24,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 168, "s": [0] },
                { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 172, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 197, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 198, "s": [0] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 201, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 202, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 208, "s": [100] },
                { "t": 217, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 167,
                  "s": [396.475, 60.72, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 180, "s": [239.475, 60.72, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [179.475, 0.72, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.096, 1.696],
                        [0, 0],
                        [0.561, -0.111],
                        [0.496, 0.096],
                        [0.383, 0.24],
                        [0.191, 0.288],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -1.599],
                        [0, 0],
                        [-0.574, 0.448],
                        [-0.561, 0.113],
                        [-0.496, -0.096],
                        [-0.385, -0.24],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [201.164, 26.585],
                        [201.164, 35.462],
                        [162.775, 35.462],
                        [162.775, 26.585],
                        [176.836, 26.585],
                        [176.836, -13.867],
                        [176.98, -18.81],
                        [166.998, -10.46],
                        [165.295, -9.621],
                        [163.711, -9.596],
                        [162.393, -10.1],
                        [161.529, -10.892],
                        [157.785, -16.026],
                        [178.947, -34.021],
                        [188.688, -34.021],
                        [188.688, 26.585]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 167,
          "op": 218,
          "st": 167,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 27,
          "ty": 4,
          "nm": "number - Group 11",
          "parent": 24,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 173, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 177, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 215, "s": [100] },
                { "t": 224, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 172,
                  "s": [340.669, 60.768, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 185, "s": [183.669, 60.768, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [123.669, 0.768, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 5.022],
                        [0.734, 3.295],
                        [1.23, 1.952],
                        [1.6, 0.784],
                        [1.729, 0],
                        [1.584, -0.784],
                        [1.217, -1.951],
                        [0.719, -3.295],
                        [0, -5.022],
                        [-0.721, -3.295],
                        [-1.215, -1.95],
                        [-1.584, -0.783],
                        [-1.695, 0],
                        [-1.6, 0.785],
                        [-1.232, 1.952],
                        [-0.736, 3.295]
                      ],
                      "o": [
                        [0, -5.022],
                        [-0.736, -3.295],
                        [-1.232, -1.951],
                        [-1.6, -0.784],
                        [-1.695, 0],
                        [-1.584, 0.784],
                        [-1.215, 1.952],
                        [-0.721, 3.295],
                        [0, 5.022],
                        [0.719, 3.295],
                        [1.217, 1.952],
                        [1.584, 0.785],
                        [1.729, 0],
                        [1.6, -0.783],
                        [1.23, -1.95],
                        [0.734, -3.295]
                      ],
                      "v": [
                        [136.865, 0.769],
                        [135.762, -11.708],
                        [132.811, -19.577],
                        [128.562, -23.68],
                        [123.572, -24.856],
                        [118.654, -23.68],
                        [114.455, -19.577],
                        [111.553, -11.708],
                        [110.473, 0.769],
                        [111.553, 13.245],
                        [114.455, 21.114],
                        [118.654, 25.217],
                        [123.572, 26.393],
                        [128.562, 25.217],
                        [132.811, 21.114],
                        [135.762, 13.245]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, -6.078],
                        [1.295, -4.463],
                        [2.287, -2.911],
                        [3.119, -1.423],
                        [3.615, 0],
                        [3.088, 1.423],
                        [2.271, 2.911],
                        [1.279, 4.462],
                        [0, 6.046],
                        [-1.279, 4.447],
                        [-2.271, 2.911],
                        [-3.088, 1.424],
                        [-3.615, 0],
                        [-3.119, -1.423],
                        [-2.287, -2.911],
                        [-1.297, -4.446]
                      ],
                      "o": [
                        [0, 6.046],
                        [-1.297, 4.462],
                        [-2.287, 2.911],
                        [-3.119, 1.423],
                        [-3.615, 0],
                        [-3.088, -1.423],
                        [-2.271, -2.911],
                        [-1.279, -4.463],
                        [0, -6.078],
                        [1.279, -4.446],
                        [2.271, -2.911],
                        [3.088, -1.423],
                        [3.615, 0],
                        [3.119, 1.424],
                        [2.287, 2.911],
                        [1.295, 4.447]
                      ],
                      "v": [
                        [149.102, 0.769],
                        [147.158, 16.532],
                        [141.783, 27.593],
                        [133.674, 34.095],
                        [123.572, 36.229],
                        [113.52, 34.095],
                        [105.482, 27.593],
                        [100.156, 16.532],
                        [98.236, 0.769],
                        [100.156, -15.019],
                        [105.482, -26.055],
                        [113.52, -32.558],
                        [123.572, -34.693],
                        [133.674, -32.558],
                        [141.783, -26.055],
                        [147.158, -15.019]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }
          ],
          "ip": 192,
          "op": 197,
          "st": 172,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 28,
          "ty": 4,
          "nm": "number - Group 2",
          "parent": 24,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 166, "s": [0] },
                { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 170, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 192, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 193, "s": [0] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 196, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 197, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 208, "s": [100] },
                { "t": 217, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 165,
                  "s": [340.669, 60.768, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 178, "s": [183.669, 60.768, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [123.669, 0.768, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 5.022],
                        [0.734, 3.295],
                        [1.23, 1.952],
                        [1.6, 0.784],
                        [1.729, 0],
                        [1.584, -0.784],
                        [1.217, -1.951],
                        [0.719, -3.295],
                        [0, -5.022],
                        [-0.721, -3.295],
                        [-1.215, -1.95],
                        [-1.584, -0.783],
                        [-1.695, 0],
                        [-1.6, 0.785],
                        [-1.232, 1.952],
                        [-0.736, 3.295]
                      ],
                      "o": [
                        [0, -5.022],
                        [-0.736, -3.295],
                        [-1.232, -1.951],
                        [-1.6, -0.784],
                        [-1.695, 0],
                        [-1.584, 0.784],
                        [-1.215, 1.952],
                        [-0.721, 3.295],
                        [0, 5.022],
                        [0.719, 3.295],
                        [1.217, 1.952],
                        [1.584, 0.785],
                        [1.729, 0],
                        [1.6, -0.783],
                        [1.23, -1.95],
                        [0.734, -3.295]
                      ],
                      "v": [
                        [136.865, 0.769],
                        [135.762, -11.708],
                        [132.811, -19.577],
                        [128.562, -23.68],
                        [123.572, -24.856],
                        [118.654, -23.68],
                        [114.455, -19.577],
                        [111.553, -11.708],
                        [110.473, 0.769],
                        [111.553, 13.245],
                        [114.455, 21.114],
                        [118.654, 25.217],
                        [123.572, 26.393],
                        [128.562, 25.217],
                        [132.811, 21.114],
                        [135.762, 13.245]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, -6.078],
                        [1.295, -4.463],
                        [2.287, -2.911],
                        [3.119, -1.423],
                        [3.615, 0],
                        [3.088, 1.423],
                        [2.271, 2.911],
                        [1.279, 4.462],
                        [0, 6.046],
                        [-1.279, 4.447],
                        [-2.271, 2.911],
                        [-3.088, 1.424],
                        [-3.615, 0],
                        [-3.119, -1.423],
                        [-2.287, -2.911],
                        [-1.297, -4.446]
                      ],
                      "o": [
                        [0, 6.046],
                        [-1.297, 4.462],
                        [-2.287, 2.911],
                        [-3.119, 1.423],
                        [-3.615, 0],
                        [-3.088, -1.423],
                        [-2.271, -2.911],
                        [-1.279, -4.463],
                        [0, -6.078],
                        [1.279, -4.446],
                        [2.271, -2.911],
                        [3.088, -1.423],
                        [3.615, 0],
                        [3.119, 1.424],
                        [2.287, 2.911],
                        [1.295, 4.447]
                      ],
                      "v": [
                        [149.102, 0.769],
                        [147.158, 16.532],
                        [141.783, 27.593],
                        [133.674, 34.095],
                        [123.572, 36.229],
                        [113.52, 34.095],
                        [105.482, 27.593],
                        [100.156, 16.532],
                        [98.236, 0.769],
                        [100.156, -15.019],
                        [105.482, -26.055],
                        [113.52, -32.558],
                        [123.572, -34.693],
                        [133.674, -32.558],
                        [141.783, -26.055],
                        [147.158, -15.019]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 165,
          "op": 218,
          "st": 165,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 29,
          "ty": 4,
          "nm": "number - Group 10",
          "parent": 24,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 171, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 175, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 215, "s": [100] },
                { "t": 224, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 170,
                  "s": [285.008, 60.768, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 183, "s": [128.008, 60.768, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [68.008, 0.768, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 5.022],
                        [0.736, 3.295],
                        [1.232, 1.952],
                        [1.6, 0.784],
                        [1.727, 0],
                        [1.582, -0.784],
                        [1.215, -1.951],
                        [0.721, -3.295],
                        [0, -5.022],
                        [-0.719, -3.295],
                        [-1.217, -1.95],
                        [-1.584, -0.783],
                        [-1.695, 0],
                        [-1.6, 0.785],
                        [-1.23, 1.952],
                        [-0.736, 3.295]
                      ],
                      "o": [
                        [0, -5.022],
                        [-0.736, -3.295],
                        [-1.23, -1.951],
                        [-1.6, -0.784],
                        [-1.695, 0],
                        [-1.584, 0.784],
                        [-1.217, 1.952],
                        [-0.719, 3.295],
                        [0, 5.022],
                        [0.721, 3.295],
                        [1.215, 1.952],
                        [1.582, 0.785],
                        [1.727, 0],
                        [1.6, -0.783],
                        [1.232, -1.95],
                        [0.736, -3.295]
                      ],
                      "v": [
                        [81.203, 0.769],
                        [80.1, -11.708],
                        [77.148, -19.577],
                        [72.902, -23.68],
                        [67.912, -24.856],
                        [62.994, -23.68],
                        [58.795, -19.577],
                        [55.891, -11.708],
                        [54.812, 0.769],
                        [55.891, 13.245],
                        [58.795, 21.114],
                        [62.994, 25.217],
                        [67.912, 26.393],
                        [72.902, 25.217],
                        [77.148, 21.114],
                        [80.1, 13.245]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, -6.078],
                        [1.297, -4.463],
                        [2.285, -2.911],
                        [3.117, -1.423],
                        [3.615, 0],
                        [3.086, 1.423],
                        [2.27, 2.911],
                        [1.279, 4.462],
                        [0, 6.046],
                        [-1.279, 4.447],
                        [-2.273, 2.911],
                        [-3.088, 1.424],
                        [-3.615, 0],
                        [-3.119, -1.423],
                        [-2.289, -2.911],
                        [-1.295, -4.446]
                      ],
                      "o": [
                        [0, 6.046],
                        [-1.295, 4.462],
                        [-2.289, 2.911],
                        [-3.119, 1.423],
                        [-3.615, 0],
                        [-3.088, -1.423],
                        [-2.273, -2.911],
                        [-1.279, -4.463],
                        [0, -6.078],
                        [1.279, -4.446],
                        [2.27, -2.911],
                        [3.086, -1.423],
                        [3.615, 0],
                        [3.117, 1.424],
                        [2.285, 2.911],
                        [1.297, 4.447]
                      ],
                      "v": [
                        [93.439, 0.769],
                        [91.496, 16.532],
                        [86.123, 27.593],
                        [78.014, 34.095],
                        [67.912, 36.229],
                        [57.859, 34.095],
                        [49.822, 27.593],
                        [44.494, 16.532],
                        [42.576, 0.769],
                        [44.494, -15.019],
                        [49.822, -26.055],
                        [57.859, -32.558],
                        [67.912, -34.693],
                        [78.014, -32.558],
                        [86.123, -26.055],
                        [91.496, -15.019]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }
          ],
          "ip": 187,
          "op": 192,
          "st": 170,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 30,
          "ty": 4,
          "nm": "number - Group 3",
          "parent": 24,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 164, "s": [0] },
                { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 168, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 187, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 188, "s": [0] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 191, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 192, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 208, "s": [100] },
                { "t": 217, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 163,
                  "s": [285.008, 60.768, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 176, "s": [128.008, 60.768, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [68.008, 0.768, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 5.022],
                        [0.736, 3.295],
                        [1.232, 1.952],
                        [1.6, 0.784],
                        [1.727, 0],
                        [1.582, -0.784],
                        [1.215, -1.951],
                        [0.721, -3.295],
                        [0, -5.022],
                        [-0.719, -3.295],
                        [-1.217, -1.95],
                        [-1.584, -0.783],
                        [-1.695, 0],
                        [-1.6, 0.785],
                        [-1.23, 1.952],
                        [-0.736, 3.295]
                      ],
                      "o": [
                        [0, -5.022],
                        [-0.736, -3.295],
                        [-1.23, -1.951],
                        [-1.6, -0.784],
                        [-1.695, 0],
                        [-1.584, 0.784],
                        [-1.217, 1.952],
                        [-0.719, 3.295],
                        [0, 5.022],
                        [0.721, 3.295],
                        [1.215, 1.952],
                        [1.582, 0.785],
                        [1.727, 0],
                        [1.6, -0.783],
                        [1.232, -1.95],
                        [0.736, -3.295]
                      ],
                      "v": [
                        [81.203, 0.769],
                        [80.1, -11.708],
                        [77.148, -19.577],
                        [72.902, -23.68],
                        [67.912, -24.856],
                        [62.994, -23.68],
                        [58.795, -19.577],
                        [55.891, -11.708],
                        [54.812, 0.769],
                        [55.891, 13.245],
                        [58.795, 21.114],
                        [62.994, 25.217],
                        [67.912, 26.393],
                        [72.902, 25.217],
                        [77.148, 21.114],
                        [80.1, 13.245]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, -6.078],
                        [1.297, -4.463],
                        [2.285, -2.911],
                        [3.117, -1.423],
                        [3.615, 0],
                        [3.086, 1.423],
                        [2.27, 2.911],
                        [1.279, 4.462],
                        [0, 6.046],
                        [-1.279, 4.447],
                        [-2.273, 2.911],
                        [-3.088, 1.424],
                        [-3.615, 0],
                        [-3.119, -1.423],
                        [-2.289, -2.911],
                        [-1.295, -4.446]
                      ],
                      "o": [
                        [0, 6.046],
                        [-1.295, 4.462],
                        [-2.289, 2.911],
                        [-3.119, 1.423],
                        [-3.615, 0],
                        [-3.088, -1.423],
                        [-2.273, -2.911],
                        [-1.279, -4.463],
                        [0, -6.078],
                        [1.279, -4.446],
                        [2.27, -2.911],
                        [3.086, -1.423],
                        [3.615, 0],
                        [3.117, 1.424],
                        [2.285, 2.911],
                        [1.297, 4.447]
                      ],
                      "v": [
                        [93.439, 0.769],
                        [91.496, 16.532],
                        [86.123, 27.593],
                        [78.014, 34.095],
                        [67.912, 36.229],
                        [57.859, 34.095],
                        [49.822, 27.593],
                        [44.494, 16.532],
                        [42.576, 0.769],
                        [44.494, -15.019],
                        [49.822, -26.055],
                        [57.859, -32.558],
                        [67.912, -34.693],
                        [78.014, -32.558],
                        [86.123, -26.055],
                        [91.496, -15.019]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 163,
          "op": 218,
          "st": 163,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 31,
          "ty": 4,
          "nm": "number - Group 9",
          "parent": 12,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 169, "s": [0] },
                { "t": 173, "s": [100] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 168,
                  "s": [229.49, 60.72, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 181, "s": [72.49, 60.72, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [12.49, 0.72, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.096, 1.696],
                        [0, 0],
                        [0.56, -0.111],
                        [0.496, 0.096],
                        [0.384, 0.24],
                        [0.191, 0.288],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -1.599],
                        [0, 0],
                        [-0.575, 0.448],
                        [-0.561, 0.113],
                        [-0.496, -0.096],
                        [-0.384, -0.24],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [34.18, 26.585],
                        [34.18, 35.462],
                        [-4.209, 35.462],
                        [-4.209, 26.585],
                        [9.85, 26.585],
                        [9.85, -13.867],
                        [9.994, -18.81],
                        [0.013, -10.46],
                        [-1.69, -9.621],
                        [-3.274, -9.596],
                        [-4.593, -10.1],
                        [-5.457, -10.892],
                        [-9.2, -16.026],
                        [11.961, -34.021],
                        [21.703, -34.021],
                        [21.703, 26.585]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            }
          ],
          "ip": 182,
          "op": 187,
          "st": 168,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 32,
          "ty": 4,
          "nm": "number - Group 4",
          "parent": 24,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 162, "s": [0] },
                { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 166, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 182, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 183, "s": [0] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 186, "s": [0] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 187, "s": [100] },
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 208, "s": [100] },
                { "t": 217, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.326, "y": 1 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 161,
                  "s": [229.49, 60.72, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 174, "s": [72.49, 60.72, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [12.49, 0.72, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-0.096, 1.696],
                        [0, 0],
                        [0.56, -0.111],
                        [0.496, 0.096],
                        [0.384, 0.24],
                        [0.191, 0.288],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, -1.599],
                        [0, 0],
                        [-0.575, 0.448],
                        [-0.561, 0.113],
                        [-0.496, -0.096],
                        [-0.384, -0.24],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [34.18, 26.585],
                        [34.18, 35.462],
                        [-4.209, 35.462],
                        [-4.209, 26.585],
                        [9.85, 26.585],
                        [9.85, -13.867],
                        [9.994, -18.81],
                        [0.013, -10.46],
                        [-1.69, -9.621],
                        [-3.274, -9.596],
                        [-4.593, -10.1],
                        [-5.457, -10.892],
                        [-9.2, -16.026],
                        [11.961, -34.021],
                        [21.703, -34.021],
                        [21.703, 26.585]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 161,
          "op": 218,
          "st": 161,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 33,
          "ty": 4,
          "nm": "icon",
          "parent": 34,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 208, "s": [100] },
                { "t": 217, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [-119.079, 0.044, 0], "ix": 2 },
            "a": { "a": 0, "k": [-119.079, 0.044, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.277, 0.277, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.526, 0.526, 0.333], "y": [0, 0, 0] },
                  "t": 148,
                  "s": [0, 0, 100]
                },
                { "t": 164, "s": [100, 100, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-1.009, 1.022],
                        [-6.966, 2.444],
                        [-0.294, 0.624],
                        [0.229, 0.65],
                        [0, 0],
                        [-11.674, -3.235],
                        [0, 0],
                        [-0.306, -0.623],
                        [-0.66, -0.22],
                        [-5.375, -5.306],
                        [-1.009, 1.022],
                        [0, 0],
                        [1.022, 1.009],
                        [27.203, -27.558],
                        [-1.022, -1.009],
                        [0, 0]
                      ],
                      "o": [
                        [5.306, -5.375],
                        [0.661, -0.225],
                        [0.298, -0.627],
                        [0, 0],
                        [11.635, -3.382],
                        [0, 0],
                        [-0.224, 0.656],
                        [0.306, 0.616],
                        [6.997, 2.353],
                        [1.022, 1.009],
                        [0, 0],
                        [1.009, -1.022],
                        [-27.558, -27.203],
                        [-1.009, 1.022],
                        [0, 0],
                        [1.022, 1.009]
                      ],
                      "v": [
                        [-153.938, 17.396],
                        [-135.443, 5.611],
                        [-133.958, 4.278],
                        [-133.853, 2.283],
                        [-137.004, -6.572],
                        [-101.311, -6.804],
                        [-104.335, 2.095],
                        [-104.205, 4.088],
                        [-102.699, 5.399],
                        [-84.052, 16.942],
                        [-80.374, 16.918],
                        [-69.411, 5.812],
                        [-69.435, 2.134],
                        [-168.747, 2.778],
                        [-168.723, 6.456],
                        [-157.617, 17.419]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.662745118141, 0.792156875134, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "icon",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 148,
          "op": 218,
          "st": 148,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 34,
          "ty": 4,
          "nm": "icon_BG",
          "parent": 24,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 208, "s": [100] },
                { "t": 217, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.199, "y": 1 },
                  "o": { "x": 0.542, "y": 0 },
                  "t": 157,
                  "s": [65.721, 60.468, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 174, "s": [-59.079, 60.468, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [-119.079, 0.468, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.413, 0.413, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.541, 0.541, 0.333], "y": [0, 0, 0] },
                  "t": 148,
                  "s": [0, 0, 100]
                },
                { "t": 161, "s": [100, 100, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [40.392, 0],
                        [0, -40.392],
                        [-40.392, 0],
                        [0, 40.392]
                      ],
                      "o": [
                        [-40.392, 0],
                        [0, 40.392],
                        [40.392, 0],
                        [0, -40.392]
                      ],
                      "v": [
                        [-119.079, -72.668],
                        [-192.215, 0.468],
                        [-119.079, 73.604],
                        [-45.943, 0.468]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.854901969433, 0.945098042488, 0.964705884457, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "icon_BG",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 148,
          "op": 218,
          "st": 148,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 35,
          "ty": 4,
          "nm": "tab",
          "parent": 24,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.333], "y": [0] }, "t": 208, "s": [100] },
                { "t": 217, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [60, 60, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.373, 0.395, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.515, 0.579, 0.333], "y": [0, 0, 0] },
                  "t": 148,
                  "s": [100, 0, 100]
                },
                { "t": 161, "s": [100, 100, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [311.389, -104.716],
                        [-293.478, -104.716],
                        [-293.478, 105.652],
                        [311.389, 105.652]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0, 0.662745118141, 0.792156875134, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "tab",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 148,
          "op": 218,
          "st": 148,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 36,
          "ty": 4,
          "nm": "BG 2",
          "parent": 43,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 392, "s": [5] },
                { "t": 410, "s": [16] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [348.9, -558.815, 0], "ix": 2 },
            "a": { "a": 0, "k": [348.9, -558.815, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, -145.736],
                        [145.736, 0],
                        [0, 145.736],
                        [-145.736, 0]
                      ],
                      "o": [
                        [0, 145.736],
                        [-145.736, 0],
                        [0, -145.736],
                        [145.736, 0]
                      ],
                      "v": [
                        [612.778, -558.815],
                        [348.9, -294.936],
                        [85.021, -558.815],
                        [348.9, -822.693]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "gf",
                  "o": { "a": 0, "k": 100, "ix": 10 },
                  "r": 1,
                  "bm": 0,
                  "g": {
                    "p": 3,
                    "k": {
                      "a": 0,
                      "k": [0, 0.165, 0.749, 0.157, 0.636, 0.582, 0.875, 0.578, 1, 1, 1, 1, 0, 1, 0.636, 0.5, 1, 0],
                      "ix": 9
                    }
                  },
                  "s": { "a": 0, "k": [99.202, -343.589], "ix": 5 },
                  "e": { "a": 0, "k": [562.387, -741.927], "ix": 6 },
                  "t": 1,
                  "nm": "Gradient Fill 1",
                  "mn": "ADBE Vector Graphic - G-Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 392,
          "op": 547,
          "st": 392,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 37,
          "ty": 3,
          "nm": "\rbubble_CTRL 2",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 0, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.342, "y": 1 },
                  "o": { "x": 0.407, "y": 0 },
                  "t": 74,
                  "s": [1146.213, 851.845, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 99,
                  "s": [1146.213, 498.595, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.788, "y": 1 },
                  "o": { "x": 0.847, "y": 0 },
                  "t": 132,
                  "s": [1146.213, 498.595, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 151, "s": [1146.213, 212.845, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [60, 60, 0], "ix": 1 },
            "s": { "a": 0, "k": [75, 75, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 71,
          "op": 152,
          "st": 72,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 38,
          "ty": 4,
          "nm": "\rmask 2",
          "parent": 37,
          "td": 1,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [-140.284, 733.873, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [133.333, 133.333, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [224.5, -624.5],
                        [223.75, -542],
                        [289.25, -505.062],
                        [289, -454.812],
                        [289.25, -437.75],
                        [302, -434],
                        [300, -378],
                        [426, -575.5]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.714338235294, 0.059593825247, 0.059593825247, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Shape 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 71,
          "op": 152,
          "st": 72,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 39,
          "ty": 4,
          "nm": "\rconnector_dad 2",
          "parent": 37,
          "tt": 2,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 145, "s": [100] },
                { "t": 151, "s": [1] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.558, "y": 0.248 },
                  "o": { "x": 0.379, "y": 0 },
                  "t": 73,
                  "s": [-161.532, 213.325, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.537, "y": 1 },
                  "o": { "x": 1, "y": 0.519 },
                  "t": 103,
                  "s": [-97.532, 178.658, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 129, "s": [81.46, 75.734, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [-114.892, 5.496, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-51.95, 4.602],
                        [-0.429, 0.315],
                        [-7.824, -10.651],
                        [10.652, -7.823],
                        [45.577, -5.996],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [49.038, -4.344],
                        [10.655, -7.824],
                        [7.822, 10.653],
                        [-2.001, 1.47],
                        [-60.567, 7.968],
                        [0, 0],
                        [142.822, -0.624]
                      ],
                      "v": [
                        [-144.077, 37.787],
                        [-64.326, 15.66],
                        [-30.872, 20.782],
                        [-35.996, 54.236],
                        [-114.507, 84.282],
                        [-325.766, 92.17],
                        [-334.178, 42.686]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-44.923, -39.101],
                        [29.735, 2.977],
                        [29.735, 60.974]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-7.594, 13.496],
                        [29.735, 2.977],
                        [104.393, -39.101]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [69.956, -32.48],
                            [92.29, -45.067]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.903, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [59.412, -38.482],
                            [81.746, -51.07]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.903, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [48.869, -44.485],
                            [71.203, -57.072]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.903, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 3",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 3,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [38.325, -50.487],
                            [60.659, -63.075]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.903, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 4",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 4,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [27.782, -56.49],
                            [50.116, -69.077]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.903, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 5",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 5,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [17.238, -62.492],
                            [39.572, -75.08]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.903, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 6",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 6,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 6,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-82.252, -28.581],
                        [-44.923, -39.101],
                        [29.735, -81.178],
                        [104.393, -39.101],
                        [104.393, 19.897],
                        [29.735, 61.974],
                        [-7.594, 88.17]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 5",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-82.252, 22.855],
                        [-82.252, -28.581],
                        [-7.594, 13.496],
                        [-7.594, 88.17],
                        [-51.169, 63.611]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 6",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 6,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }
          ],
          "ip": 71,
          "op": 152,
          "st": 72,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 40,
          "ty": 4,
          "nm": "Lan_icon 3",
          "parent": 37,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 145, "s": [100] },
                { "t": 151, "s": [1] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [214.307, -57.44, 0], "ix": 2 },
            "a": { "a": 0, "k": [460.52, -700.844, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "ef": [
            {
              "ty": 25,
              "nm": "Drop Shadow",
              "np": 8,
              "mn": "ADBE Drop Shadow",
              "ix": 1,
              "en": 1,
              "ef": [
                {
                  "ty": 2,
                  "nm": "Shadow Color",
                  "mn": "ADBE Drop Shadow-0001",
                  "ix": 1,
                  "v": { "a": 0, "k": [1, 0.407843142748, 0.113725490868, 1], "ix": 1 }
                },
                {
                  "ty": 0,
                  "nm": "Opacity",
                  "mn": "ADBE Drop Shadow-0002",
                  "ix": 2,
                  "v": {
                    "a": 1,
                    "k": [
                      { "t": 106, "s": [0], "h": 1 },
                      { "t": 107, "s": [0], "h": 1 },
                      { "t": 108, "s": [178.5], "h": 1 },
                      { "t": 109, "s": [51], "h": 1 },
                      { "t": 110, "s": [178.5], "h": 1 },
                      {
                        "i": { "x": [0.622], "y": [1.26] },
                        "o": { "x": [0.169], "y": [-0.194] },
                        "t": 111,
                        "s": [68.85]
                      },
                      { "t": 118, "s": [138.813] }
                    ],
                    "ix": 2
                  }
                },
                {
                  "ty": 0,
                  "nm": "Direction",
                  "mn": "ADBE Drop Shadow-0003",
                  "ix": 3,
                  "v": { "a": 0, "k": 135, "ix": 3 }
                },
                { "ty": 0, "nm": "Distance", "mn": "ADBE Drop Shadow-0004", "ix": 4, "v": { "a": 0, "k": 0, "ix": 4 } },
                {
                  "ty": 0,
                  "nm": "Softness",
                  "mn": "ADBE Drop Shadow-0005",
                  "ix": 5,
                  "v": { "a": 0, "k": 16, "ix": 5 }
                },
                {
                  "ty": 7,
                  "nm": "Shadow Only",
                  "mn": "ADBE Drop Shadow-0006",
                  "ix": 6,
                  "v": { "a": 0, "k": 0, "ix": 6 }
                }
              ]
            }
          ],
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [440.694, -718.415],
                        [440.694, -700.61]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [427.476, -679.987],
                        [427.476, -707.931],
                        [452.243, -693.959],
                        [452.255, -666.009]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [482.003, -695.609],
                        [482.003, -677.804]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [462.563, -724.37],
                        [462.563, -706.565]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 4,
                  "ty": "sh",
                  "ix": 5,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [468.785, -657.182],
                        [468.785, -685.125],
                        [493.552, -671.154],
                        [493.564, -643.203]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 5,
                  "ty": "sh",
                  "ix": 6,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [451.622, -730.542],
                        [451.622, -758.485],
                        [476.39, -744.513],
                        [476.401, -716.563]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 6,
                  "ty": "sh",
                  "ix": 7,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [440.694, -718.415],
                        [482.003, -695.609]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 7",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                { "ty": "mm", "mm": 1, "nm": "Merge Paths 1", "mn": "ADBE Vector Filter - Merge", "hd": false },
                {
                  "ty": "gs",
                  "o": {
                    "a": 1,
                    "k": [
                      { "t": 106, "s": [100], "h": 1 },
                      { "t": 107, "s": [0], "h": 1 },
                      { "t": 108, "s": [100], "h": 1 },
                      { "t": 109, "s": [54], "h": 1 },
                      { "t": 110, "s": [100], "h": 1 },
                      { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "t": 111, "s": [27] },
                      { "t": 117, "s": [100] }
                    ],
                    "ix": 9
                  },
                  "w": { "a": 0, "k": 8, "ix": 10 },
                  "g": {
                    "p": 3,
                    "k": {
                      "a": 0,
                      "k": [0, 1, 0.408, 0.114, 0.5, 0.751, 0.455, 0.308, 1, 0.502, 0.502, 0.502],
                      "ix": 8
                    }
                  },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": 0.667, "y": 1 },
                        "o": { "x": 0.333, "y": 0 },
                        "t": 108.75,
                        "s": [444.013, -639.159],
                        "to": [0, 0],
                        "ti": [0, 0]
                      },
                      { "t": 111, "s": [477.982, -756.867] }
                    ],
                    "ix": 4
                  },
                  "e": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": 0.667, "y": 1 },
                        "o": { "x": 0.333, "y": 0 },
                        "t": 105,
                        "s": [448.799, -652.484],
                        "to": [0, 0],
                        "ti": [0, 0]
                      },
                      { "t": 107.25, "s": [510.734, -853.93] }
                    ],
                    "ix": 5
                  },
                  "t": 1,
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Gradient Stroke 1",
                  "mn": "ADBE Vector Graphic - G-Stroke",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 8, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 10,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 71,
          "op": 152,
          "st": 70,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 41,
          "ty": 4,
          "nm": "\r\rconnector_mam 2",
          "parent": 37,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 145, "s": [100] },
                { "t": 151, "s": [1] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [202.793, 78.585, 0], "ix": 2 },
            "a": { "a": 0, "k": [449.006, -564.82, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [474.16, -522.497],
                        [493.818, -533.576]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [458.726, -531.052],
                        [493.801, -550.82]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [428.863, -521.358],
                        [493.083, -557.552]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [428.863, -547.645],
                        [493.083, -583.839]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [415.677, -555.16],
                        [479.296, -591.016]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 5",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [404.211, -562.489],
                        [467.831, -598.345]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 6",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 6,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [428.861, -547.657],
                        [404.228, -561.539],
                        [404.228, -635.13],
                        [493.818, -584.637],
                        [493.818, -511.047],
                        [458.726, -530.985]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 7",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 7,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [458.726, -530.985],
                        [458.726, -504.573],
                        [428.863, -521.232],
                        [428.863, -547.645]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 8",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 8,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-6.175, -3.48],
                        [0, 0],
                        [0, -6.131],
                        [0, 0],
                        [6.175, 3.48],
                        [0, 0],
                        [0, 6.131],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [5.341, 3.01],
                        [0, 0],
                        [0, 7.089],
                        [0, 0],
                        [-5.341, -3.01],
                        [0, 0],
                        [0, -7.089]
                      ],
                      "v": [
                        [388.16, -670.417],
                        [515.019, -598.919],
                        [523.664, -584.124],
                        [523.664, -467.293],
                        [509.852, -459.223],
                        [382.993, -530.721],
                        [374.348, -545.516],
                        [374.348, -662.347]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 9",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 9,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 71,
          "op": 152,
          "st": 72,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 42,
          "ty": 3,
          "nm": "\rbubble_CTRL",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 0, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.342, "y": 1 },
                  "o": { "x": 0.255, "y": 0 },
                  "t": 2,
                  "s": [1146.213, 851.845, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.667, "y": 0.667 },
                  "o": { "x": 0.333, "y": 0.333 },
                  "t": 23,
                  "s": [1146.213, 498.595, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.788, "y": 1 },
                  "o": { "x": 0.847, "y": 0 },
                  "t": 70,
                  "s": [1146.213, 498.595, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 87, "s": [1146.213, 212.845, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [60, 60, 0], "ix": 1 },
            "s": { "a": 0, "k": [75, 75, 100], "ix": 6 }
          },
          "ao": 0,
          "ip": 0,
          "op": 88,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 43,
          "ty": 4,
          "nm": "bubble",
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [1206.228, 516.038, 0], "ix": 2 },
            "a": { "a": 0, "k": [348.9, -558.815, 0], "ix": 1 },
            "s": {
              "a": 1,
              "k": [
                {
                  "i": { "x": [0.273, 0.273, 0.667], "y": [1, 1, 1] },
                  "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
                  "t": 1,
                  "s": [0, 0, 100]
                },
                { "t": 20, "s": [75, 75, 100] }
              ],
              "ix": 6
            }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "d": 1,
                  "ty": "el",
                  "s": { "a": 0, "k": [527.757, 527.757], "ix": 2 },
                  "p": { "a": 0, "k": [348.9, -558.815], "ix": 3 },
                  "nm": "Ellipse Path 1",
                  "mn": "ADBE Vector Shape - Ellipse",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 1,
          "op": 23,
          "st": 1,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 44,
          "ty": 4,
          "nm": "\rmask",
          "parent": 42,
          "td": 1,
          "sr": 1,
          "ks": {
            "o": { "a": 0, "k": 100, "ix": 11 },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [-140.284, 733.873, 0], "ix": 2 },
            "a": { "a": 0, "k": [0, 0, 0], "ix": 1 },
            "s": { "a": 0, "k": [133.333, 133.333, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [224.5, -624.5],
                        [223.75, -542],
                        [289.25, -505.062],
                        [289, -454.812],
                        [289.25, -437.75],
                        [302, -434],
                        [300, -378],
                        [426, -575.5]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.714338235294, 0.059593825247, 0.059593825247, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Shape 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 88,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 45,
          "ty": 4,
          "nm": "\rconnector_dad",
          "parent": 42,
          "tt": 2,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 82, "s": [100] },
                { "t": 88, "s": [1] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": {
              "a": 1,
              "k": [
                {
                  "i": { "x": 0.452, "y": 0 },
                  "o": { "x": 0.333, "y": 0 },
                  "t": 4,
                  "s": [-161.532, 213.325, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                {
                  "i": { "x": 0.383, "y": 1 },
                  "o": { "x": 0.819, "y": 0.456 },
                  "t": 34,
                  "s": [-97.532, 178.658, 0],
                  "to": [0, 0, 0],
                  "ti": [0, 0, 0]
                },
                { "t": 60, "s": [81.46, 75.734, 0] }
              ],
              "ix": 2
            },
            "a": { "a": 0, "k": [-114.892, 5.496, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-51.95, 4.602],
                        [-0.429, 0.315],
                        [-7.824, -10.651],
                        [10.652, -7.823],
                        [45.577, -5.996],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [49.038, -4.344],
                        [10.655, -7.824],
                        [7.822, 10.653],
                        [-2.001, 1.47],
                        [-60.567, 7.968],
                        [0, 0],
                        [142.822, -0.624]
                      ],
                      "v": [
                        [-144.077, 37.787],
                        [-64.326, 15.66],
                        [-30.872, 20.782],
                        [-35.996, 54.236],
                        [-114.507, 84.282],
                        [-325.766, 92.17],
                        [-334.178, 42.686]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-44.923, -39.101],
                        [29.735, 2.977],
                        [29.735, 60.974]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-7.594, 13.496],
                        [29.735, 2.977],
                        [104.393, -39.101]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [69.956, -32.48],
                            [92.29, -45.067]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.903, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [59.412, -38.482],
                            [81.746, -51.07]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.903, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [48.869, -44.485],
                            [71.203, -57.072]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.903, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 3",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 3,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [38.325, -50.487],
                            [60.659, -63.075]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.903, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 4",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 4,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [27.782, -56.49],
                            [50.116, -69.077]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.903, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 5",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 5,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [17.238, -62.492],
                            [39.572, -75.08]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.903, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 6",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 6,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 6,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-82.252, -28.581],
                        [-44.923, -39.101],
                        [29.735, -81.178],
                        [104.393, -39.101],
                        [104.393, 19.897],
                        [29.735, 61.974],
                        [-7.594, 88.17]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 5",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-82.252, 22.855],
                        [-82.252, -28.581],
                        [-7.594, 13.496],
                        [-7.594, 88.17],
                        [-51.169, 63.611]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 6",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 6,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 88,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 46,
          "ty": 4,
          "nm": "Lan_icon 2",
          "parent": 42,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 82, "s": [100] },
                { "t": 88, "s": [1] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [214.307, -57.44, 0], "ix": 2 },
            "a": { "a": 0, "k": [460.52, -700.844, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "ef": [
            {
              "ty": 25,
              "nm": "Drop Shadow",
              "np": 8,
              "mn": "ADBE Drop Shadow",
              "ix": 1,
              "en": 1,
              "ef": [
                {
                  "ty": 2,
                  "nm": "Shadow Color",
                  "mn": "ADBE Drop Shadow-0001",
                  "ix": 1,
                  "v": { "a": 0, "k": [1, 0.407843142748, 0.113725490868, 1], "ix": 1 }
                },
                {
                  "ty": 0,
                  "nm": "Opacity",
                  "mn": "ADBE Drop Shadow-0002",
                  "ix": 2,
                  "v": {
                    "a": 1,
                    "k": [
                      { "t": 44, "s": [0], "h": 1 },
                      { "t": 45, "s": [0], "h": 1 },
                      { "t": 46, "s": [178.5], "h": 1 },
                      { "t": 47, "s": [51], "h": 1 },
                      { "t": 48, "s": [178.5], "h": 1 },
                      {
                        "i": { "x": [0.622], "y": [1.26] },
                        "o": { "x": [0.169], "y": [-0.194] },
                        "t": 49,
                        "s": [68.85]
                      },
                      { "t": 56, "s": [138.813] }
                    ],
                    "ix": 2
                  }
                },
                {
                  "ty": 0,
                  "nm": "Direction",
                  "mn": "ADBE Drop Shadow-0003",
                  "ix": 3,
                  "v": { "a": 0, "k": 135, "ix": 3 }
                },
                { "ty": 0, "nm": "Distance", "mn": "ADBE Drop Shadow-0004", "ix": 4, "v": { "a": 0, "k": 0, "ix": 4 } },
                {
                  "ty": 0,
                  "nm": "Softness",
                  "mn": "ADBE Drop Shadow-0005",
                  "ix": 5,
                  "v": { "a": 0, "k": 16, "ix": 5 }
                },
                {
                  "ty": 7,
                  "nm": "Shadow Only",
                  "mn": "ADBE Drop Shadow-0006",
                  "ix": 6,
                  "v": { "a": 0, "k": 0, "ix": 6 }
                }
              ]
            }
          ],
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [440.694, -718.415],
                        [440.694, -700.61]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [427.476, -679.987],
                        [427.476, -707.931],
                        [452.243, -693.959],
                        [452.255, -666.009]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [482.003, -695.609],
                        [482.003, -677.804]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [462.563, -724.37],
                        [462.563, -706.565]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 4,
                  "ty": "sh",
                  "ix": 5,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [468.785, -657.182],
                        [468.785, -685.125],
                        [493.552, -671.154],
                        [493.564, -643.203]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 5,
                  "ty": "sh",
                  "ix": 6,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [451.622, -730.542],
                        [451.622, -758.485],
                        [476.39, -744.513],
                        [476.401, -716.563]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 6,
                  "ty": "sh",
                  "ix": 7,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [440.694, -718.415],
                        [482.003, -695.609]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 7",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                { "ty": "mm", "mm": 1, "nm": "Merge Paths 1", "mn": "ADBE Vector Filter - Merge", "hd": false },
                {
                  "ty": "gs",
                  "o": {
                    "a": 1,
                    "k": [
                      { "t": 44, "s": [100], "h": 1 },
                      { "t": 45, "s": [0], "h": 1 },
                      { "t": 46, "s": [100], "h": 1 },
                      { "t": 47, "s": [54], "h": 1 },
                      { "t": 48, "s": [100], "h": 1 },
                      { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0.167] }, "t": 49, "s": [27] },
                      { "t": 55, "s": [100] }
                    ],
                    "ix": 9
                  },
                  "w": { "a": 0, "k": 8, "ix": 10 },
                  "g": {
                    "p": 3,
                    "k": {
                      "a": 0,
                      "k": [0, 1, 0.408, 0.114, 0.5, 0.751, 0.455, 0.308, 1, 0.502, 0.502, 0.502],
                      "ix": 8
                    }
                  },
                  "s": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": 0.667, "y": 1 },
                        "o": { "x": 0.333, "y": 0 },
                        "t": 46.75,
                        "s": [444.013, -639.159],
                        "to": [0, 0],
                        "ti": [0, 0]
                      },
                      { "t": 49, "s": [477.982, -756.867] }
                    ],
                    "ix": 4
                  },
                  "e": {
                    "a": 1,
                    "k": [
                      {
                        "i": { "x": 0.667, "y": 1 },
                        "o": { "x": 0.333, "y": 0 },
                        "t": 43,
                        "s": [448.799, -652.484],
                        "to": [0, 0],
                        "ti": [0, 0]
                      },
                      { "t": 45.25, "s": [510.734, -853.93] }
                    ],
                    "ix": 5
                  },
                  "t": 1,
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Gradient Stroke 1",
                  "mn": "ADBE Vector Graphic - G-Stroke",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 8, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 10,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": -2,
          "op": 88,
          "st": -2,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 47,
          "ty": 4,
          "nm": "\r\rconnector_mam",
          "parent": 42,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 82, "s": [100] },
                { "t": 88, "s": [1] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [202.793, 78.585, 0], "ix": 2 },
            "a": { "a": 0, "k": [449.006, -564.82, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [474.16, -522.497],
                        [493.818, -533.576]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [458.726, -531.052],
                        [493.801, -550.82]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [428.863, -521.358],
                        [493.083, -557.552]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [428.863, -547.645],
                        [493.083, -583.839]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [415.677, -555.16],
                        [479.296, -591.016]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 5",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [404.211, -562.489],
                        [467.831, -598.345]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 6",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 6,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [428.861, -547.657],
                        [404.228, -561.539],
                        [404.228, -635.13],
                        [493.818, -584.637],
                        [493.818, -511.047],
                        [458.726, -530.985]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 7",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 7,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [458.726, -530.985],
                        [458.726, -504.573],
                        [428.863, -521.232],
                        [428.863, -547.645]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 8",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 8,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-6.175, -3.48],
                        [0, 0],
                        [0, -6.131],
                        [0, 0],
                        [6.175, 3.48],
                        [0, 0],
                        [0, 6.131],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [5.341, 3.01],
                        [0, 0],
                        [0, 7.089],
                        [0, 0],
                        [-5.341, -3.01],
                        [0, 0],
                        [0, -7.089]
                      ],
                      "v": [
                        [388.16, -670.417],
                        [515.019, -598.919],
                        [523.664, -584.124],
                        [523.664, -467.293],
                        [509.852, -459.223],
                        [382.993, -530.721],
                        [374.348, -545.516],
                        [374.348, -662.347]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 6.176, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 9",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 9,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 94,
          "st": 0,
          "bm": 0
        },
        {
          "ddd": 0,
          "ind": 48,
          "ty": 4,
          "nm": "BG",
          "parent": 43,
          "sr": 1,
          "ks": {
            "o": {
              "a": 1,
              "k": [
                { "i": { "x": [0.833], "y": [0.833] }, "o": { "x": [0.167], "y": [0.167] }, "t": 147, "s": [20] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 152, "s": [100] },
                { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 393, "s": [100] },
                { "t": 410, "s": [0] }
              ],
              "ix": 11
            },
            "r": { "a": 0, "k": 0, "ix": 10 },
            "p": { "a": 0, "k": [348.9, -558.815, 0], "ix": 2 },
            "a": { "a": 0, "k": [348.9, -558.815, 0], "ix": 1 },
            "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
          },
          "ao": 0,
          "shapes": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, -145.736],
                        [145.736, 0],
                        [0, 145.736],
                        [-145.736, 0]
                      ],
                      "o": [
                        [0, 145.736],
                        [-145.736, 0],
                        [0, -145.736],
                        [145.736, 0]
                      ],
                      "v": [
                        [612.778, -558.815],
                        [348.9, -294.936],
                        [85.021, -558.815],
                        [348.9, -822.693]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "gf",
                  "o": { "a": 0, "k": 100, "ix": 10 },
                  "r": 1,
                  "bm": 0,
                  "g": {
                    "p": 3,
                    "k": {
                      "a": 1,
                      "k": [
                        {
                          "i": { "x": 0.833, "y": 0.833 },
                          "o": { "x": 0.167, "y": 0.167 },
                          "t": 139,
                          "s": [0, 1, 0.408, 0.114, 0.636, 1, 0.704, 0.557, 1, 1, 1, 1, 0, 1, 0.636, 0.5, 1, 0]
                        },
                        {
                          "t": 148,
                          "s": [0, 0.855, 0.945, 0.965, 0.636, 0.927, 0.973, 0.982, 1, 1, 1, 1, 0, 1, 0.636, 0.5, 1, 0]
                        }
                      ],
                      "ix": 9
                    }
                  },
                  "s": { "a": 0, "k": [99.202, -343.589], "ix": 5 },
                  "e": { "a": 0, "k": [562.387, -741.927], "ix": 6 },
                  "t": 1,
                  "nm": "Gradient Fi2",
                  "mn": "ADBE Vector Graphic - G-Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            }
          ],
          "ip": 0,
          "op": 444,
          "st": 0,
          "bm": 0
        }
      ]
    }
  ],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "bubble",
      "td": 1,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [1206.228, 516.038, 0], "ix": 2 },
        "a": { "a": 0, "k": [348.9, -558.815, 0], "ix": 1 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.273, 0.273, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 1,
              "s": [0, 0, 100]
            },
            { "t": 20, "s": [75, 75, 100] }
          ],
          "ix": 6
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "d": 1,
              "ty": "el",
              "s": { "a": 0, "k": [527.757, 527.757], "ix": 2 },
              "p": { "a": 0, "k": [348.9, -558.815], "ix": 3 },
              "nm": "Ellipse Path 1",
              "mn": "ADBE Vector Shape - Ellipse",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 6, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "fl",
          "c": { "a": 0, "k": [1, 0, 0, 1], "ix": 4 },
          "o": { "a": 0, "k": 100, "ix": 5 },
          "r": 1,
          "bm": 0,
          "nm": "Fill 1",
          "mn": "ADBE Vector Graphic - Fill",
          "hd": false
        }
      ],
      "ip": 1,
      "op": 495,
      "st": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 0,
      "nm": "\rmain",
      "tt": 1,
      "refId": "comp_0",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [1000, 1000, 0], "ix": 2 },
        "a": { "a": 0, "k": [1000, 1000, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "w": 2000,
      "h": 2000,
      "ip": 0,
      "op": 500,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "\rline to bubble",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [1206, 844.841, 0], "ix": 2 },
        "a": { "a": 0, "k": [220, -155.159, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "hasMask": true,
      "masksProperties": [
        {
          "inv": false,
          "mode": "a",
          "pt": {
            "a": 0,
            "k": {
              "i": [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0]
              ],
              "o": [
                [0, 0],
                [0, 0],
                [0, 0],
                [0, 0]
              ],
              "v": [
                [240, -286],
                [205, -285],
                [207, -160],
                [233, -146]
              ],
              "c": true
            },
            "ix": 1
          },
          "o": { "a": 0, "k": 100, "ix": 3 },
          "x": { "a": 0, "k": 0, "ix": 4 },
          "nm": "Mask 1"
        }
      ],
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [220, -141.75],
                    [220, -300]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 7, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "d": [
                { "n": "d", "nm": "dash", "v": { "a": 0, "k": 0, "ix": 1 } },
                { "n": "g", "nm": "gap", "v": { "a": 0, "k": 16.6, "ix": 2 } },
                {
                  "n": "o",
                  "nm": "offset",
                  "v": { "a": 0, "k": 0, "ix": 7, "x": "var $bm_rt;\n$bm_rt = $bm_mul(time, -25);" }
                }
              ],
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Shape 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "tm",
          "s": { "a": 0, "k": 0, "ix": 1 },
          "e": {
            "a": 1,
            "k": [
              { "i": { "x": [0.295], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 0, "s": [0] },
              { "t": 21, "s": [99] }
            ],
            "ix": 2
          },
          "o": { "a": 0, "k": 0, "ix": 3 },
          "m": 1,
          "ix": 2,
          "nm": "Trim Paths 1",
          "mn": "ADBE Vector Filter - Trim",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 501,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 3,
      "nm": "\rphone_CTRL",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 0, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [931, 1105, 0], "ix": 2 },
        "a": { "a": 0, "k": [60, 60, 0], "ix": 1 },
        "s": { "a": 0, "k": [75, 75, 100], "ix": 6 }
      },
      "ao": 0,
      "ip": 0,
      "op": 501,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 4,
      "nm": "\rshadow",
      "parent": 4,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 20, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [637.453, 237.041, 0], "ix": 2 },
        "a": { "a": 0, "k": [577.453, 177.041, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [31.569, 16.113],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [716.02, 285.71],
                    [565.931, 370.311],
                    [534.679, 352.673],
                    [556.116, 340.6],
                    [438.886, 238.914],
                    [474.781, 178.165],
                    [460.107, 107.433],
                    [534.284, -16.229]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "gf",
              "o": { "a": 0, "k": 100, "ix": 10 },
              "r": 1,
              "bm": 0,
              "g": {
                "p": 3,
                "k": {
                  "a": 0,
                  "k": [0, 0.263, 0.659, 0.78, 0.636, 0.631, 0.829, 0.89, 1, 1, 1, 1, 0, 1, 0.636, 0.5, 1, 0],
                  "ix": 9
                }
              },
              "s": { "a": 0, "k": [447.202, 247.627], "ix": 5 },
              "e": { "a": 0, "k": [604.127, 147.766], "ix": 6 },
              "t": 1,
              "nm": "Gradient Fill 1",
              "mn": "ADBE Vector Graphic - G-Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 501,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 6,
      "ty": 4,
      "nm": "\rshadow 2",
      "parent": 4,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 20, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [469.991, 474.17, 0], "ix": 2 },
        "a": { "a": 0, "k": [409.991, 414.17, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [254.05, 545.561],
                    [270.542, 518.356],
                    [411.982, 282.78],
                    [565.931, 370.311]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.262745112181, 0.658823549747, 0.780392169952, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 501,
      "st": 0,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 7,
      "ty": 4,
      "nm": "main",
      "parent": 4,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [-30.108, 47.615, 0], "ix": 2 },
        "a": { "a": 0, "k": [-90.108, -12.385, 0], "ix": 1 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [43.668, -21.097],
                    [27.301, 0],
                    [0.428, 0.003],
                    [35.299, 19.895],
                    [0.21, 20.24],
                    [-33.804, 19.987],
                    [-69.562, -39.205]
                  ],
                  "o": [
                    [-1.018, 1.331],
                    [-25.377, 12.26],
                    [-0.428, 0],
                    [-34.495, -0.246],
                    [-48.335, -27.241],
                    [-0.294, -28.303],
                    [48.984, -28.962],
                    [0, 0]
                  ],
                  "v": [
                    [-479.095, 82.969],
                    [-548.198, 136.902],
                    [-627.575, 155.375],
                    [-628.859, 155.37],
                    [-734.043, 125.016],
                    [-792.983, 47.69],
                    [-740.253, -28.296],
                    [-541.143, -29.728]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5.35, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [44.476, -26.297],
                    [-0.226, -21.76],
                    [-32.39, -18.255],
                    [-31.435, -0.224],
                    [-23.296, 11.255],
                    [-4.541, 5.513]
                  ],
                  "o": [
                    [-63.271, -35.434],
                    [-28.172, 16.657],
                    [0.231, 22.29],
                    [32.635, 18.393],
                    [24.971, 0.166],
                    [35.476, -17.139],
                    [0, 0]
                  ],
                  "v": [
                    [-550.313, -14.426],
                    [-731.177, -12.946],
                    [-775.152, 47.505],
                    [-725.287, 109.481],
                    [-628.732, 137.538],
                    [-555.956, 120.846],
                    [-494.145, 73.237]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5.35, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [1.1, 0.613],
                        [0.691, -1.147],
                        [-1.1, -0.613],
                        [-0.691, 1.147]
                      ],
                      "o": [
                        [-1.1, -0.613],
                        [-0.691, 1.147],
                        [1.1, 0.613],
                        [0.691, -1.147]
                      ],
                      "v": [
                        [-182.271, 22.029],
                        [-185.515, 22.995],
                        [-184.774, 26.183],
                        [-181.53, 25.216]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.244, 0.138],
                        [0, 0],
                        [-0.121, 0.274],
                        [0, 0],
                        [0.123, 0.297],
                        [0, 0],
                        [-0.013, 0.292],
                        [0, 0],
                        [-0.288, 0.054],
                        [0, 0],
                        [-0.207, 0.272],
                        [0, 0],
                        [-0.259, 0.153],
                        [0, 0],
                        [-0.172, -0.221],
                        [0, 0],
                        [-0.326, -0.02],
                        [0, 0],
                        [-0.244, -0.137],
                        [0, 0],
                        [0.12, -0.274],
                        [0, 0],
                        [-0.123, -0.297],
                        [0, 0],
                        [0.013, -0.292],
                        [0, 0],
                        [0.288, -0.054],
                        [0, 0],
                        [0.206, -0.272],
                        [0, 0],
                        [0.252, -0.156],
                        [0, 0],
                        [0.172, 0.221],
                        [0, 0],
                        [0.326, 0.02],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-0.248, -0.136],
                        [0, 0],
                        [-0.182, -0.262],
                        [0, 0],
                        [-0.286, -0.037],
                        [0, 0],
                        [0.012, -0.29],
                        [0, 0],
                        [0.143, -0.308],
                        [0, 0],
                        [-0.098, -0.268],
                        [0, 0],
                        [0.255, -0.156],
                        [0, 0],
                        [0.328, -0.044],
                        [0, 0],
                        [0.186, -0.233],
                        [0, 0],
                        [0.248, 0.136],
                        [0, 0],
                        [0.182, 0.261],
                        [0, 0],
                        [0.286, 0.038],
                        [0, 0],
                        [-0.012, 0.29],
                        [0, 0],
                        [-0.143, 0.308],
                        [0, 0],
                        [0.095, 0.265],
                        [0, 0],
                        [-0.255, 0.156],
                        [0, 0],
                        [-0.328, 0.044],
                        [0, 0],
                        [-0.187, 0.234]
                      ],
                      "v": [
                        [-185.943, 30.477],
                        [-188.068, 29.292],
                        [-188.291, 28.576],
                        [-187.675, 27.143],
                        [-188.133, 26.304],
                        [-189.637, 26.138],
                        [-190.112, 25.566],
                        [-190.018, 23.065],
                        [-189.497, 22.468],
                        [-187.977, 22.206],
                        [-187.451, 21.333],
                        [-187.969, 19.935],
                        [-187.688, 19.201],
                        [-185.472, 17.879],
                        [-184.727, 17.992],
                        [-183.827, 19.169],
                        [-182.843, 19.133],
                        [-181.854, 17.902],
                        [-181.103, 17.734],
                        [-178.978, 18.919],
                        [-178.756, 19.635],
                        [-179.372, 21.068],
                        [-178.914, 21.907],
                        [-177.409, 22.073],
                        [-176.935, 22.645],
                        [-177.027, 25.146],
                        [-177.548, 25.743],
                        [-179.069, 26.006],
                        [-179.594, 26.879],
                        [-179.076, 28.277],
                        [-179.349, 29.006],
                        [-181.572, 30.333],
                        [-182.316, 30.22],
                        [-183.217, 29.043],
                        [-184.202, 29.078],
                        [-185.19, 30.309]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ty": "gr",
                      "it": [
                        {
                          "ind": 0,
                          "ty": "sh",
                          "ix": 1,
                          "ks": {
                            "a": 0,
                            "k": {
                              "i": [
                                [-0.403, 0.123],
                                [-2.074, -0.326],
                                [-0.167, 0.119],
                                [-0.044, 0.196],
                                [0, 0],
                                [-2.353, -2.411],
                                [0, 0],
                                [0.021, -0.2],
                                [-0.127, -0.146],
                                [-0.498, -2.081],
                                [-0.403, 0.123],
                                [0, 0],
                                [0.095, 0.396],
                                [10.862, -3.31],
                                [-0.095, -0.396],
                                [0, 0]
                              ],
                              "o": [
                                [2.119, -0.646],
                                [0.196, 0.033],
                                [0.169, -0.119],
                                [0, 0],
                                [3.358, 0.722],
                                [0, 0],
                                [-0.155, 0.136],
                                [-0.02, 0.198],
                                [1.347, 1.55],
                                [0.095, 0.396],
                                [0, 0],
                                [0.403, -0.123],
                                [-2.554, -10.669],
                                [-0.403, 0.123],
                                [0, 0],
                                [0.095, 0.396]
                              ],
                              "v": [
                                [256.808, 132.72],
                                [263.128, 132.239],
                                [263.695, 132.101],
                                [264.026, 131.608],
                                [264.614, 128.927],
                                [273.359, 133.724],
                                [271.257, 135.576],
                                [270.984, 136.101],
                                [271.15, 136.639],
                                [273.931, 142.112],
                                [274.832, 142.606],
                                [279.209, 141.272],
                                [279.767, 140.333],
                                [255.436, 126.988],
                                [254.878, 127.926],
                                [255.907, 132.226]
                              ],
                              "c": true
                            },
                            "ix": 2
                          },
                          "nm": "Path 1",
                          "mn": "ADBE Vector Shape - Group",
                          "hd": false
                        },
                        {
                          "ty": "fl",
                          "c": { "a": 0, "k": [0.262745112181, 0.658823549747, 0.780392169952, 1], "ix": 4 },
                          "o": { "a": 0, "k": 100, "ix": 5 },
                          "r": 1,
                          "bm": 0,
                          "nm": "Fill 1",
                          "mn": "ADBE Vector Graphic - Fill",
                          "hd": false
                        },
                        {
                          "ty": "tr",
                          "p": { "a": 0, "k": [0, 0], "ix": 2 },
                          "a": { "a": 0, "k": [0, 0], "ix": 1 },
                          "s": { "a": 0, "k": [100, 100], "ix": 3 },
                          "r": { "a": 0, "k": 0, "ix": 6 },
                          "o": { "a": 0, "k": 100, "ix": 7 },
                          "sk": { "a": 0, "k": 0, "ix": 4 },
                          "sa": { "a": 0, "k": 0, "ix": 5 },
                          "nm": "Transform"
                        }
                      ],
                      "nm": "Group 1",
                      "np": 2,
                      "cix": 2,
                      "bm": 0,
                      "ix": 1,
                      "mn": "ADBE Vector Group",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 1,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [198.419, 387.557],
                            [198.287, 386.659],
                            [209.595, 384.222],
                            [209.728, 385.12]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [197.658, 390.907],
                            [202.637, 393.682],
                            [201.523, 395.531],
                            [196.544, 392.755]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [-1.027, -0.573],
                            [0, 0],
                            [0.645, -1.071],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0.645, -1.071],
                            [0, 0],
                            [1.027, 0.573],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [201.14, 386.507],
                            [204.144, 381.523],
                            [207.185, 380.617],
                            [207.185, 380.617],
                            [207.879, 383.605],
                            [206.874, 385.272]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 3",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 3,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [1.027, 0.573],
                            [0, 0],
                            [-0.645, 1.071],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [-0.645, 1.071],
                            [0, 0],
                            [-1.027, -0.573],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [206.051, 386.638],
                            [203.545, 390.797],
                            [200.504, 391.702],
                            [200.504, 391.702],
                            [199.81, 388.715],
                            [200.317, 387.874]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 4",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 4,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.659, 0.367],
                            [0, 0],
                            [-0.414, 0.687],
                            [0, 0],
                            [-0.659, -0.367],
                            [0, 0],
                            [0.414, -0.687],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [-0.659, -0.367],
                            [0, 0],
                            [0.414, -0.687],
                            [0, 0],
                            [0.659, 0.367],
                            [0, 0],
                            [-0.414, 0.687]
                          ],
                          "v": [
                            [188.173, 339.335],
                            [188.147, 339.32],
                            [187.702, 337.404],
                            [189.227, 334.873],
                            [191.177, 334.293],
                            [191.203, 334.307],
                            [191.648, 336.223],
                            [190.123, 338.754]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.659, 0.367],
                            [0, 0],
                            [-0.414, 0.687],
                            [0, 0],
                            [-0.659, -0.367],
                            [0, 0],
                            [0.414, -0.687],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [-0.659, -0.367],
                            [0, 0],
                            [0.414, -0.687],
                            [0, 0],
                            [0.659, 0.367],
                            [0, 0],
                            [-0.414, 0.687]
                          ],
                          "v": [
                            [181.863, 335.817],
                            [181.837, 335.803],
                            [181.392, 333.887],
                            [182.917, 331.356],
                            [184.867, 330.775],
                            [184.892, 330.789],
                            [185.338, 332.705],
                            [183.812, 335.236]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-0.909, 1.508],
                        [2.91, 1.622],
                        [1.828, -3.033],
                        [-0.255, -1.442],
                        [-0.022, -0.095]
                      ],
                      "o": [
                        [1.541, -0.467],
                        [1.828, -3.033],
                        [-2.91, -1.622],
                        [-0.852, 1.413],
                        [0.017, 0.096],
                        [0, 0]
                      ],
                      "v": [
                        [190.44, 336.846],
                        [194.296, 333.831],
                        [192.337, 325.402],
                        [183.759, 327.957],
                        [182.897, 332.387],
                        [182.956, 332.673]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 2.613, "ix": 5 },
                  "lc": 2,
                  "lj": 1,
                  "ml": 10,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 5",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [257.626, 374.491],
                            [259.505, 380.553],
                            [268.025, 366.414],
                            [261.735, 367.671]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.262745112181, 0.658823549747, 0.780392169952, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [259.006, 375.26],
                            [254.685, 372.851],
                            [258.795, 366.032],
                            [263.115, 368.441]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.262745112181, 0.658823549747, 0.780392169952, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 6",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 6,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ty": "gr",
                      "it": [
                        {
                          "ind": 0,
                          "ty": "sh",
                          "ix": 1,
                          "ks": {
                            "a": 0,
                            "k": {
                              "i": [
                                [0.564, -0.93],
                                [0.95, 0.528],
                                [-0.564, 0.93],
                                [-0.95, -0.528]
                              ],
                              "o": [
                                [-0.564, 0.93],
                                [-0.95, -0.528],
                                [0.564, -0.93],
                                [0.95, 0.528]
                              ],
                              "v": [
                                [315.489, 302.801],
                                [312.746, 303.527],
                                [312.048, 300.887],
                                [314.79, 300.161]
                              ],
                              "c": true
                            },
                            "ix": 2
                          },
                          "nm": "Path 1",
                          "mn": "ADBE Vector Shape - Group",
                          "hd": false
                        },
                        {
                          "ty": "fl",
                          "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                          "o": { "a": 0, "k": 100, "ix": 5 },
                          "r": 1,
                          "bm": 0,
                          "nm": "Fill 1",
                          "mn": "ADBE Vector Graphic - Fill",
                          "hd": false
                        },
                        {
                          "ty": "tr",
                          "p": { "a": 0, "k": [0, 0], "ix": 2 },
                          "a": { "a": 0, "k": [0, 0], "ix": 1 },
                          "s": { "a": 0, "k": [100, 100], "ix": 3 },
                          "r": { "a": 0, "k": 0, "ix": 6 },
                          "o": { "a": 0, "k": 100, "ix": 7 },
                          "sk": { "a": 0, "k": 0, "ix": 4 },
                          "sa": { "a": 0, "k": 0, "ix": 5 },
                          "nm": "Transform"
                        }
                      ],
                      "nm": "Group 1",
                      "np": 2,
                      "cix": 2,
                      "bm": 0,
                      "ix": 1,
                      "mn": "ADBE Vector Group",
                      "hd": false
                    },
                    {
                      "ty": "gr",
                      "it": [
                        {
                          "ind": 0,
                          "ty": "sh",
                          "ix": 1,
                          "ks": {
                            "a": 0,
                            "k": {
                              "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [-1.397, -0.777],
                                [0, 0],
                                [0.83, -1.367]
                              ],
                              "o": [
                                [0, 0],
                                [0, 0],
                                [0.83, -1.367],
                                [0, 0],
                                [1.397, 0.777],
                                [0, 0]
                              ],
                              "v": [
                                [313.918, 308.958],
                                [307.238, 305.243],
                                [307.904, 304.145],
                                [311.937, 303.077],
                                [313.556, 303.978],
                                [314.584, 307.86]
                              ],
                              "c": true
                            },
                            "ix": 2
                          },
                          "nm": "Path 1",
                          "mn": "ADBE Vector Shape - Group",
                          "hd": false
                        },
                        {
                          "ty": "fl",
                          "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                          "o": { "a": 0, "k": 100, "ix": 5 },
                          "r": 1,
                          "bm": 0,
                          "nm": "Fill 1",
                          "mn": "ADBE Vector Graphic - Fill",
                          "hd": false
                        },
                        {
                          "ty": "tr",
                          "p": { "a": 0, "k": [0, 0], "ix": 2 },
                          "a": { "a": 0, "k": [0, 0], "ix": 1 },
                          "s": { "a": 0, "k": [100, 100], "ix": 3 },
                          "r": { "a": 0, "k": 0, "ix": 6 },
                          "o": { "a": 0, "k": 100, "ix": 7 },
                          "sk": { "a": 0, "k": 0, "ix": 4 },
                          "sa": { "a": 0, "k": 0, "ix": 5 },
                          "nm": "Transform"
                        }
                      ],
                      "nm": "Group 2",
                      "np": 2,
                      "cix": 2,
                      "bm": 0,
                      "ix": 2,
                      "mn": "ADBE Vector Group",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ty": "gr",
                      "it": [
                        {
                          "ind": 0,
                          "ty": "sh",
                          "ix": 1,
                          "ks": {
                            "a": 0,
                            "k": {
                              "i": [
                                [0.564, -0.93],
                                [0.95, 0.528],
                                [-0.564, 0.93],
                                [-0.95, -0.528]
                              ],
                              "o": [
                                [-0.564, 0.93],
                                [-0.95, -0.528],
                                [0.564, -0.93],
                                [0.95, 0.528]
                              ],
                              "v": [
                                [301.286, 294.902],
                                [298.543, 295.629],
                                [297.844, 292.988],
                                [300.587, 292.262]
                              ],
                              "c": true
                            },
                            "ix": 2
                          },
                          "nm": "Path 1",
                          "mn": "ADBE Vector Shape - Group",
                          "hd": false
                        },
                        {
                          "ty": "fl",
                          "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                          "o": { "a": 0, "k": 100, "ix": 5 },
                          "r": 1,
                          "bm": 0,
                          "nm": "Fill 1",
                          "mn": "ADBE Vector Graphic - Fill",
                          "hd": false
                        },
                        {
                          "ty": "tr",
                          "p": { "a": 0, "k": [0, 0], "ix": 2 },
                          "a": { "a": 0, "k": [0, 0], "ix": 1 },
                          "s": { "a": 0, "k": [100, 100], "ix": 3 },
                          "r": { "a": 0, "k": 0, "ix": 6 },
                          "o": { "a": 0, "k": 100, "ix": 7 },
                          "sk": { "a": 0, "k": 0, "ix": 4 },
                          "sa": { "a": 0, "k": 0, "ix": 5 },
                          "nm": "Transform"
                        }
                      ],
                      "nm": "Group 1",
                      "np": 2,
                      "cix": 2,
                      "bm": 0,
                      "ix": 1,
                      "mn": "ADBE Vector Group",
                      "hd": false
                    },
                    {
                      "ty": "gr",
                      "it": [
                        {
                          "ind": 0,
                          "ty": "sh",
                          "ix": 1,
                          "ks": {
                            "a": 0,
                            "k": {
                              "i": [
                                [0, 0],
                                [0, 0],
                                [0, 0],
                                [-1.397, -0.777],
                                [0, 0],
                                [0.83, -1.367]
                              ],
                              "o": [
                                [0, 0],
                                [0, 0],
                                [0.83, -1.367],
                                [0, 0],
                                [1.397, 0.777],
                                [0, 0]
                              ],
                              "v": [
                                [299.714, 301.059],
                                [293.034, 297.344],
                                [293.7, 296.247],
                                [297.733, 295.178],
                                [299.353, 296.079],
                                [300.38, 299.961]
                              ],
                              "c": true
                            },
                            "ix": 2
                          },
                          "nm": "Path 1",
                          "mn": "ADBE Vector Shape - Group",
                          "hd": false
                        },
                        {
                          "ty": "fl",
                          "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                          "o": { "a": 0, "k": 100, "ix": 5 },
                          "r": 1,
                          "bm": 0,
                          "nm": "Fill 1",
                          "mn": "ADBE Vector Graphic - Fill",
                          "hd": false
                        },
                        {
                          "ty": "tr",
                          "p": { "a": 0, "k": [0, 0], "ix": 2 },
                          "a": { "a": 0, "k": [0, 0], "ix": 1 },
                          "s": { "a": 0, "k": [100, 100], "ix": 3 },
                          "r": { "a": 0, "k": 0, "ix": 6 },
                          "o": { "a": 0, "k": 100, "ix": 7 },
                          "sk": { "a": 0, "k": 0, "ix": 4 },
                          "sa": { "a": 0, "k": 0, "ix": 5 },
                          "nm": "Transform"
                        }
                      ],
                      "nm": "Group 2",
                      "np": 2,
                      "cix": 2,
                      "bm": 0,
                      "ix": 2,
                      "mn": "ADBE Vector Group",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 7",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 7,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.958, -1.579],
                            [1.614, 0.897],
                            [-0.958, 1.579],
                            [-1.614, -0.897]
                          ],
                          "o": [
                            [-0.958, 1.579],
                            [-1.614, -0.897],
                            [0.958, -1.579],
                            [1.614, 0.897]
                          ],
                          "v": [
                            [310.24, 298.447],
                            [305.582, 299.681],
                            [304.396, 295.197],
                            [309.053, 293.964]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [-2.373, -1.32],
                            [0, 0],
                            [1.409, -2.322]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [1.409, -2.322],
                            [0, 0],
                            [2.373, 1.32],
                            [0, 0]
                          ],
                          "v": [
                            [307.571, 308.903],
                            [296.227, 302.594],
                            [297.358, 300.731],
                            [304.207, 298.916],
                            [306.957, 300.446],
                            [308.702, 307.04]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 8",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 8,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.855, -1.418],
                            [1.36, 0.758],
                            [-0.855, 1.418],
                            [-1.36, -0.758]
                          ],
                          "o": [
                            [-0.855, 1.418],
                            [-1.36, -0.758],
                            [0.855, -1.418],
                            [1.36, 0.758]
                          ],
                          "v": [
                            [237.73, 257.499],
                            [233.72, 258.693],
                            [232.804, 254.753],
                            [236.814, 253.558]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [-2, -1.115],
                            [0, 0],
                            [1.257, -2.085]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [1.257, -2.085],
                            [0, 0],
                            [2, 1.115],
                            [0, 0]
                          ],
                          "v": [
                            [235.217, 266.808],
                            [225.655, 261.477],
                            [226.664, 259.803],
                            [232.561, 258.047],
                            [234.879, 259.339],
                            [236.225, 265.134]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 9",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 9,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [290.808, 251.135],
                            [287.83, 249.474],
                            [295.111, 237.393],
                            [298.089, 239.053]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [285.962, 248.433],
                            [282.984, 246.773],
                            [290.265, 234.691],
                            [293.243, 236.352]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 10",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 10,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [2.859, -1.528],
                        [0, 0],
                        [-2.287, 0.619],
                        [-0.24, 0.072],
                        [1.833, 1.764],
                        [0.381, 0.468],
                        [0, 0],
                        [-1.154, -2.28],
                        [-1.189, 1.973],
                        [0, 0],
                        [2.747, -3.458],
                        [-1.571, -0.082],
                        [-1.731, -0.223],
                        [0, 0],
                        [2.959, 1.036],
                        [0, 0],
                        [-0.086, -0.713],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [2.258, -0.814],
                        [0.915, -0.257],
                        [-0.413, -0.333],
                        [-1.32, -1.273],
                        [0, 0],
                        [1.795, 2.357],
                        [1.44, -3.367],
                        [0, 0],
                        [-0.842, 1.398],
                        [0.459, 0.052],
                        [2.126, 0.137],
                        [0, 0],
                        [-2.328, -0.658],
                        [0, 0],
                        [0.188, 1.154],
                        [0, 0],
                        [0, 0],
                        [-2.367, 1.443]
                      ],
                      "v": [
                        [-93.84, 245.838],
                        [-95.976, 240.157],
                        [-89.158, 238.009],
                        [-87.426, 237.516],
                        [-90.795, 234.371],
                        [-93.345, 231.76],
                        [-88.672, 227.61],
                        [-84.249, 234.566],
                        [-80.305, 226.556],
                        [-75.4, 229.29],
                        [-80.784, 236.574],
                        [-77.739, 236.775],
                        [-71.952, 237.315],
                        [-73.625, 243.329],
                        [-81.556, 240.788],
                        [-80.586, 246.51],
                        [-80.176, 249.311],
                        [-86.14, 249.862],
                        [-86, 241.381]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 11",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 11,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [65.206, 319.701],
                            [62.115, 323.178],
                            [64.925, 324.744],
                            [68.005, 321.262]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 1,
                      "ty": "sh",
                      "ix": 2,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [56.947, 324.176],
                            [55.224, 323.217],
                            [56.974, 320.313],
                            [59.253, 321.583],
                            [62.357, 318.113],
                            [59.32, 316.42],
                            [61.077, 313.503],
                            [64.685, 315.514],
                            [68.786, 310.925],
                            [71.622, 312.506],
                            [67.521, 317.096],
                            [70.32, 318.655],
                            [74.394, 314.051],
                            [77.333, 315.69],
                            [73.218, 320.272],
                            [74.964, 321.244],
                            [73.206, 324.161],
                            [70.89, 322.869],
                            [67.784, 326.34],
                            [70.861, 328.055],
                            [69.111, 330.958],
                            [65.466, 328.926],
                            [61.365, 333.516],
                            [58.54, 331.941],
                            [62.617, 327.338],
                            [59.806, 325.772],
                            [55.704, 330.359],
                            [52.843, 328.766]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 2",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 3,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 12",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 12,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [-0.854, 1.414],
                            [-0.359, 1.038],
                            [0.002, 0.736],
                            [0.299, 0.461],
                            [0.467, 0.26],
                            [0.561, 0.017],
                            [0.66, -0.366],
                            [0.754, -0.82],
                            [0.854, -1.415],
                            [0.365, -1.037],
                            [0.004, -0.732],
                            [-0.297, -0.459],
                            [-0.457, -0.256],
                            [-0.564, -0.02],
                            [-0.664, 0.363],
                            [-0.758, 0.816]
                          ],
                          "o": [
                            [0.852, -1.415],
                            [0.361, -1.039],
                            [-0.002, -0.734],
                            [-0.299, -0.462],
                            [-0.459, -0.256],
                            [-0.562, -0.019],
                            [-0.658, 0.367],
                            [-0.754, 0.818],
                            [-0.852, 1.415],
                            [-0.363, 1.036],
                            [-0.002, 0.732],
                            [0.295, 0.459],
                            [0.467, 0.26],
                            [0.564, 0.02],
                            [0.664, -0.364],
                            [0.758, -0.817]
                          ],
                          "v": [
                            [-5.913, 282.119],
                            [-4.094, 278.44],
                            [-3.555, 275.777],
                            [-4.007, 273.983],
                            [-5.155, 272.9],
                            [-6.682, 272.491],
                            [-8.514, 273.014],
                            [-10.633, 274.793],
                            [-13.044, 278.144],
                            [-14.87, 281.82],
                            [-15.421, 284.474],
                            [-14.981, 286.262],
                            [-13.854, 287.334],
                            [-12.305, 287.754],
                            [-10.462, 287.238],
                            [-8.329, 285.467]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 1,
                      "ty": "sh",
                      "ix": 2,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [1.031, -1.712],
                            [1.109, -1.062],
                            [1.111, -0.477],
                            [1.082, 0.068],
                            [0.977, 0.545],
                            [0.592, 0.865],
                            [0.119, 1.162],
                            [-0.41, 1.449],
                            [-1.027, 1.703],
                            [-1.1, 1.059],
                            [-1.107, 0.478],
                            [-1.074, -0.062],
                            [-0.977, -0.544],
                            [-0.6, -0.87],
                            [-0.125, -1.164],
                            [0.404, -1.447]
                          ],
                          "o": [
                            [-1.025, 1.703],
                            [-1.105, 1.062],
                            [-1.111, 0.475],
                            [-1.084, -0.068],
                            [-0.977, -0.545],
                            [-0.594, -0.865],
                            [-0.119, -1.163],
                            [0.412, -1.449],
                            [1.031, -1.711],
                            [1.1, -1.061],
                            [1.107, -0.478],
                            [1.076, 0.064],
                            [0.977, 0.544],
                            [0.602, 0.87],
                            [0.123, 1.164],
                            [-0.404, 1.447]
                          ],
                          "v": [
                            [-2.608, 283.962],
                            [-5.809, 288.108],
                            [-9.137, 290.414],
                            [-12.43, 291.023],
                            [-15.522, 290.104],
                            [-17.876, 287.988],
                            [-18.944, 284.947],
                            [-18.507, 281.029],
                            [-16.348, 276.301],
                            [-13.151, 272.145],
                            [-9.839, 269.838],
                            [-6.565, 269.217],
                            [-3.485, 270.13],
                            [-1.12, 272.253],
                            [-0.032, 275.305],
                            [-0.454, 279.223]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 2",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 3,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 13",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 13,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.293, -0.487],
                            [-0.193, -0.874],
                            [-0.994, -0.555],
                            [-0.51, -0.056],
                            [-0.457, 0.143],
                            [-0.389, 0.324],
                            [-0.281, 0.469],
                            [-0.098, 0.506],
                            [0.111, 0.447],
                            [0.303, 0.371],
                            [0.467, 0.26],
                            [0.488, 0.051],
                            [0.457, -0.143],
                            [0.395, -0.328]
                          ],
                          "o": [
                            [-0.656, 1.09],
                            [0.195, 0.873],
                            [0.52, 0.289],
                            [0.51, 0.055],
                            [0.455, -0.143],
                            [0.387, -0.326],
                            [0.32, -0.531],
                            [0.098, -0.506],
                            [-0.113, -0.447],
                            [-0.301, -0.373],
                            [-0.484, -0.271],
                            [-0.49, -0.05],
                            [-0.455, 0.145],
                            [-0.395, 0.327]
                          ],
                          "v": [
                            [91.392, 265.971],
                            [90.699, 268.916],
                            [92.484, 271.057],
                            [94.025, 271.573],
                            [95.474, 271.441],
                            [96.738, 270.738],
                            [97.74, 269.545],
                            [98.367, 267.99],
                            [98.345, 266.561],
                            [97.726, 265.332],
                            [96.575, 264.383],
                            [95.117, 263.902],
                            [93.697, 264.041],
                            [92.423, 264.749]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 1,
                      "ty": "sh",
                      "ix": 2,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [-0.238, 0.107],
                            [-0.23, 0.113],
                            [0.607, 0.141],
                            [0.57, 0.317],
                            [0.482, 0.582],
                            [0.199, 0.743],
                            [-0.123, 0.864],
                            [-0.564, 0.938],
                            [-0.771, 0.594],
                            [-0.908, 0.264],
                            [-0.986, -0.105],
                            [-0.951, -0.53],
                            [-0.576, -0.742],
                            [-0.195, -0.867],
                            [0.188, -0.953],
                            [0.568, -0.946],
                            [0.426, -0.485],
                            [0.484, -0.399],
                            [0.547, -0.334],
                            [0.602, -0.29],
                            [0, 0],
                            [0.383, 0.016],
                            [0.371, 0.208],
                            [0, 0]
                          ],
                          "o": [
                            [0.26, -0.107],
                            [0.238, -0.109],
                            [-0.605, 0.048],
                            [-0.607, -0.141],
                            [-0.648, -0.361],
                            [-0.48, -0.581],
                            [-0.197, -0.742],
                            [0.123, -0.865],
                            [0.527, -0.873],
                            [0.773, -0.592],
                            [0.908, -0.264],
                            [0.988, 0.104],
                            [0.959, 0.535],
                            [0.574, 0.742],
                            [0.199, 0.869],
                            [-0.188, 0.955],
                            [-0.365, 0.604],
                            [-0.426, 0.484],
                            [-0.48, 0.398],
                            [-0.547, 0.332],
                            [0, 0],
                            [-0.279, 0.134],
                            [-0.385, -0.016],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [91.972, 274.436],
                            [92.72, 274.113],
                            [93.421, 273.781],
                            [91.601, 273.643],
                            [89.833, 272.955],
                            [88.138, 271.541],
                            [87.118, 269.555],
                            [87.005, 267.145],
                            [88.034, 264.441],
                            [89.984, 262.242],
                            [92.507, 260.959],
                            [95.351, 260.722],
                            [98.259, 261.674],
                            [100.56, 263.589],
                            [101.718, 266.004],
                            [101.734, 268.738],
                            [100.597, 271.59],
                            [99.413, 273.223],
                            [98.05, 274.549],
                            [96.507, 275.647],
                            [94.783, 276.581],
                            [86.65, 280.567],
                            [85.658, 280.746],
                            [84.525, 280.412],
                            [81.581, 278.772]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 2",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 3,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 14",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 14,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.475, 0.265],
                            [0.438, 0.039],
                            [0.385, -0.129],
                            [0.309, -0.273],
                            [0.223, -0.369],
                            [0.131, -0.415],
                            [-0.045, -0.404],
                            [-0.252, -0.369],
                            [-0.52, -0.289],
                            [-0.457, -0.026],
                            [-0.387, 0.164],
                            [-0.309, 0.314],
                            [-0.234, 0.389],
                            [-0.088, 0.396],
                            [0.07, 0.383],
                            [0.252, 0.346]
                          ],
                          "o": [
                            [-0.477, -0.266],
                            [-0.438, -0.039],
                            [-0.383, 0.129],
                            [-0.309, 0.273],
                            [-0.232, 0.388],
                            [-0.127, 0.416],
                            [0.045, 0.404],
                            [0.25, 0.368],
                            [0.518, 0.289],
                            [0.457, 0.026],
                            [0.387, -0.163],
                            [0.312, -0.313],
                            [0.223, -0.369],
                            [0.09, -0.396],
                            [-0.07, -0.382],
                            [-0.256, -0.346]
                          ],
                          "v": [
                            [24.066, 224.488],
                            [22.695, 224.031],
                            [21.462, 224.166],
                            [20.423, 224.77],
                            [19.626, 225.732],
                            [19.081, 226.937],
                            [18.956, 228.166],
                            [19.402, 229.326],
                            [20.556, 230.313],
                            [22.019, 230.786],
                            [23.286, 230.58],
                            [24.331, 229.863],
                            [25.15, 228.811],
                            [25.615, 227.663],
                            [25.644, 226.496],
                            [25.159, 225.404]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 1,
                      "ty": "sh",
                      "ix": 2,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [-0.527, -0.293],
                            [-0.494, -0.064],
                            [-0.439, 0.129],
                            [-0.373, 0.311],
                            [-0.271, 0.45],
                            [0.238, 0.867],
                            [1.002, 0.559],
                            [0.9, -0.231],
                            [0.646, -1.071],
                            [0.096, -0.465],
                            [-0.104, -0.432],
                            [-0.303, -0.379]
                          ],
                          "o": [
                            [0.525, 0.295],
                            [0.492, 0.064],
                            [0.439, -0.127],
                            [0.371, -0.311],
                            [0.646, -1.071],
                            [-0.24, -0.867],
                            [-1.004, -0.56],
                            [-0.902, 0.232],
                            [-0.271, 0.451],
                            [-0.096, 0.465],
                            [0.104, 0.432],
                            [0.303, 0.379]
                          ],
                          "v": [
                            [15.117, 239.34],
                            [16.646, 239.877],
                            [18.044, 239.781],
                            [19.263, 239.125],
                            [20.228, 237.983],
                            [20.839, 235.074],
                            [18.976, 232.935],
                            [16.12, 232.443],
                            [13.798, 234.398],
                            [13.247, 235.772],
                            [13.261, 237.115],
                            [13.87, 238.33]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 2",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 2,
                      "ty": "sh",
                      "ix": 3,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [1.146, 0.11],
                            [-0.064, -1.102],
                            [0.695, -1.153],
                            [0.74, -0.527],
                            [0.869, -0.178],
                            [0.963, 0.174],
                            [0.967, 0.539],
                            [0.637, 0.716],
                            [0.271, 0.812],
                            [-0.107, 0.879],
                            [-0.521, 0.865],
                            [-1.023, 0.494],
                            [-1.375, -0.248],
                            [0.014, 0.982],
                            [-0.619, 1.026],
                            [-0.676, 0.479],
                            [-0.803, 0.185],
                            [-0.883, -0.137],
                            [-0.865, -0.482],
                            [-0.562, -0.668],
                            [-0.232, -0.762],
                            [0.098, -0.801],
                            [0.445, -0.739],
                            [0.895, -0.478]
                          ],
                          "o": [
                            [0.906, 1.023],
                            [0.064, 1.102],
                            [-0.521, 0.865],
                            [-0.738, 0.526],
                            [-0.869, 0.178],
                            [-0.963, -0.176],
                            [-0.969, -0.541],
                            [-0.635, -0.717],
                            [-0.271, -0.814],
                            [0.107, -0.879],
                            [0.695, -1.153],
                            [1.025, -0.494],
                            [-0.668, -0.902],
                            [-0.016, -0.982],
                            [0.445, -0.739],
                            [0.674, -0.479],
                            [0.805, -0.185],
                            [0.881, 0.137],
                            [0.863, 0.481],
                            [0.561, 0.668],
                            [0.232, 0.763],
                            [-0.096, 0.801],
                            [-0.619, 1.026],
                            [-0.893, 0.477]
                          ],
                          "v": [
                            [22.978, 233.306],
                            [24.435, 236.492],
                            [23.488, 239.873],
                            [21.597, 241.961],
                            [19.185, 243.018],
                            [16.439, 243.022],
                            [13.544, 241.949],
                            [11.136, 240.065],
                            [9.775, 237.772],
                            [9.529, 235.232],
                            [10.472, 232.617],
                            [13.052, 230.147],
                            [16.652, 229.779],
                            [15.628, 226.951],
                            [16.534, 223.938],
                            [18.216, 222.111],
                            [20.433, 221.118],
                            [22.962, 221.047],
                            [25.581, 221.975],
                            [27.72, 223.699],
                            [28.911, 225.844],
                            [29.117, 228.189],
                            [28.306, 230.499],
                            [26.036, 232.755]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 3",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 4,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 15",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 15,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0.246, -0.219],
                            [0.195, -0.132],
                            [0, 0],
                            [0.4, -0.07],
                            [0.447, 0.25],
                            [0, 0],
                            [0, 0],
                            [-0.316, 0.167],
                            [-0.342, 0.123],
                            [0, 0],
                            [0.055, 0.234],
                            [-0.125, 0.207],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [-0.262, 0.433],
                            [-0.246, 0.217],
                            [0, 0],
                            [-0.34, 0.234],
                            [-0.402, 0.072],
                            [0, 0],
                            [0, 0],
                            [0.348, -0.215],
                            [0.314, -0.167],
                            [0, 0],
                            [-0.201, -0.111],
                            [-0.055, -0.236],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-38.878, 186.756],
                            [-39.749, 188.202],
                            [-40.51, 189.178],
                            [-41.173, 189.701],
                            [-57.462, 200.984],
                            [-58.569, 201.441],
                            [-59.844, 201.174],
                            [-62.167, 199.88],
                            [-45.921, 188.986],
                            [-44.925, 188.413],
                            [-43.942, 187.977],
                            [-52.913, 182.976],
                            [-53.294, 182.457],
                            [-53.19, 181.793],
                            [-51.829, 179.536]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 16",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 16,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [-0.543, -0.304],
                            [-0.535, -0.058],
                            [-0.504, 0.153],
                            [-0.438, 0.341],
                            [-0.309, 0.514],
                            [-0.105, 0.538],
                            [0.115, 0.479],
                            [0.326, 0.398],
                            [0.512, 0.285],
                            [0.521, 0.051],
                            [0.486, -0.156],
                            [0.428, -0.345],
                            [0.305, -0.504],
                            [0.127, -0.525],
                            [-0.09, -0.472],
                            [-0.309, -0.406]
                          ],
                          "o": [
                            [0.51, 0.284],
                            [0.537, 0.059],
                            [0.502, -0.153],
                            [0.434, -0.34],
                            [0.336, -0.558],
                            [0.104, -0.538],
                            [-0.115, -0.479],
                            [-0.326, -0.398],
                            [-0.51, -0.283],
                            [-0.523, -0.052],
                            [-0.486, 0.156],
                            [-0.428, 0.346],
                            [-0.324, 0.541],
                            [-0.127, 0.525],
                            [0.092, 0.472],
                            [0.309, 0.407]
                          ],
                          "v": [
                            [116.781, 230.097],
                            [118.351, 230.61],
                            [119.909, 230.468],
                            [121.318, 229.727],
                            [122.435, 228.445],
                            [123.097, 226.802],
                            [123.081, 225.276],
                            [122.419, 223.959],
                            [121.165, 222.936],
                            [119.617, 222.434],
                            [118.101, 222.59],
                            [116.73, 223.342],
                            [115.632, 224.617],
                            [114.954, 226.217],
                            [114.902, 227.713],
                            [115.501, 229.03]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 1,
                      "ty": "sh",
                      "ix": 2,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [-0.482, -0.13],
                            [-0.484, -0.271],
                            [-0.523, -0.617],
                            [-0.213, -0.775],
                            [0.129, -0.902],
                            [0.586, -0.973],
                            [0.801, -0.619],
                            [0.936, -0.271],
                            [1.023, 0.113],
                            [0.986, 0.55],
                            [0.594, 0.776],
                            [0.203, 0.912],
                            [-0.211, 1.008],
                            [-0.619, 1.026],
                            [-0.941, 0.77],
                            [-1.381, 0.626],
                            [0, 0],
                            [-0.389, -0.014],
                            [-0.389, -0.217],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0.477, 0.014],
                            [0.48, 0.13],
                            [0.709, 0.395],
                            [0.523, 0.616],
                            [0.215, 0.774],
                            [-0.129, 0.903],
                            [-0.549, 0.911],
                            [-0.801, 0.619],
                            [-0.939, 0.272],
                            [-1.023, -0.112],
                            [-1.002, -0.559],
                            [-0.594, -0.776],
                            [-0.199, -0.912],
                            [0.207, -1.009],
                            [0.553, -0.919],
                            [0.943, -0.768],
                            [0, 0],
                            [0.285, -0.13],
                            [0.391, 0.013],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [122.042, 219.759],
                            [120.888, 220.235],
                            [122.327, 220.45],
                            [123.775, 221.051],
                            [125.622, 222.568],
                            [126.728, 224.656],
                            [126.857, 227.173],
                            [125.783, 229.987],
                            [123.761, 232.281],
                            [121.156, 233.617],
                            [118.214, 233.856],
                            [115.2, 232.862],
                            [112.806, 230.859],
                            [111.613, 228.326],
                            [111.628, 225.445],
                            [112.87, 222.392],
                            [115.113, 219.859],
                            [118.599, 217.769],
                            [126.843, 214.005],
                            [127.857, 213.83],
                            [129.027, 214.175],
                            [131.878, 215.765]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 2",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 3,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 17",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 17,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [-0.404, -0.171],
                            [-0.354, -0.197],
                            [-0.566, -0.726],
                            [-0.184, -0.825],
                            [0.178, -0.87],
                            [0.506, -0.838],
                            [0.865, -0.662],
                            [0.988, -0.262],
                            [1.051, 0.141],
                            [1.002, 0.559],
                            [0.451, 0.42],
                            [0.334, 0.469],
                            [0.229, 0.494],
                            [0.127, 0.48],
                            [0, 0],
                            [-0.338, -0.188],
                            [-0.139, -0.27],
                            [-0.188, -0.332],
                            [-0.307, -0.363],
                            [-0.555, -0.309],
                            [-0.57, -0.053],
                            [-0.512, 0.19],
                            [-0.449, 0.407],
                            [-0.348, 0.576],
                            [0.232, 0.929],
                            [1.156, 0.646],
                            [1.139, 0.179],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0.465, -0.138],
                            [0.684, 0.381],
                            [0, 0]
                          ],
                          "o": [
                            [0.469, 0.142],
                            [0.404, 0.171],
                            [0.986, 0.549],
                            [0.568, 0.726],
                            [0.184, 0.825],
                            [-0.178, 0.87],
                            [-0.625, 1.036],
                            [-0.865, 0.66],
                            [-0.988, 0.261],
                            [-1.053, -0.142],
                            [-0.588, -0.327],
                            [-0.451, -0.42],
                            [-0.334, -0.47],
                            [-0.227, -0.494],
                            [0, 0],
                            [0.393, -0.191],
                            [0.215, 0.12],
                            [0.137, 0.27],
                            [0.186, 0.334],
                            [0.307, 0.363],
                            [0.586, 0.328],
                            [0.568, 0.051],
                            [0.514, -0.189],
                            [0.447, -0.406],
                            [0.641, -1.063],
                            [-0.23, -0.93],
                            [-0.891, -0.497],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [-0.287, 0.478],
                            [-0.463, 0.139],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [48.71, 178.308],
                            [50.021, 178.776],
                            [51.158, 179.33],
                            [53.488, 181.242],
                            [54.615, 183.567],
                            [54.624, 186.109],
                            [53.601, 188.671],
                            [51.365, 191.217],
                            [48.583, 192.6],
                            [45.523, 192.779],
                            [42.441, 191.729],
                            [40.882, 190.607],
                            [39.702, 189.273],
                            [38.859, 187.828],
                            [38.327, 186.367],
                            [40.167, 185.498],
                            [41.263, 185.493],
                            [41.792, 186.078],
                            [42.279, 186.981],
                            [43.019, 188.025],
                            [44.308, 189.033],
                            [46.042, 189.604],
                            [47.663, 189.397],
                            [49.105, 188.502],
                            [50.296, 187.027],
                            [50.909, 184.039],
                            [48.827, 181.677],
                            [45.783, 180.665],
                            [44.144, 178.958],
                            [51.415, 170.338],
                            [60.673, 175.498],
                            [59.818, 176.917],
                            [58.689, 177.84],
                            [56.968, 177.477],
                            [51.822, 174.607]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 18",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 18,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [-0.518, 0.687],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0.363, -0.604],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-22.243, 145.574],
                            [-18.389, 139.182],
                            [-17.067, 137.246],
                            [-27.946, 142.395]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 1,
                      "ty": "sh",
                      "ix": 2,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0.191, -0.068],
                            [0.207, 0.115],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0.08, 0.231],
                            [-0.084, 0.23],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [-0.107, 0.181],
                            [-0.189, 0.067],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [-0.215, -0.121],
                            [-0.08, -0.23],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-17.096, 148.443],
                            [-18.26, 150.375],
                            [-18.71, 150.748],
                            [-19.307, 150.676],
                            [-21.018, 149.722],
                            [-23.893, 154.492],
                            [-26.68, 152.939],
                            [-23.805, 148.168],
                            [-31.714, 143.76],
                            [-32.157, 143.232],
                            [-32.153, 142.539],
                            [-31.473, 140.662],
                            [-15.141, 133.246],
                            [-12.108, 134.938],
                            [-19.456, 147.127]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 2",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 3,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 19",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 19,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [-0.799, 0.5],
                            [-0.842, 0.161],
                            [-0.865, -0.164],
                            [-0.83, -0.462],
                            [-0.541, -0.646],
                            [-0.221, -0.73],
                            [0.105, -0.761],
                            [0.43, -0.712],
                            [0.42, -0.398],
                            [0.463, -0.211],
                            [0.518, -0.037],
                            [0.566, 0.098],
                            [-0.098, -1.064],
                            [0.689, -1.145],
                            [0.797, -0.555],
                            [0.893, -0.182],
                            [0.932, 0.169],
                            [0.863, 0.482],
                            [0.564, 0.615],
                            [0.252, 0.731],
                            [-0.021, 0.843],
                            [-0.246, 0.982],
                            [0, 0],
                            [-0.277, -0.258],
                            [0.027, -0.369],
                            [-0.002, -0.41],
                            [-0.115, -0.383],
                            [-0.26, -0.346],
                            [-0.482, -0.27],
                            [-0.518, -0.042],
                            [-0.451, 0.146],
                            [-0.354, 0.29],
                            [-0.223, 0.369],
                            [-0.137, 0.436],
                            [0.139, 0.438],
                            [0.475, 0.469],
                            [0.951, 0.53],
                            [0, 0],
                            [-0.605, -0.145],
                            [-0.461, 0.086],
                            [-0.338, 0.293],
                            [-0.26, 0.433],
                            [0.207, 0.752],
                            [0.82, 0.457],
                            [0.389, 0.065],
                            [0.377, -0.06],
                            [0.336, -0.174],
                            [0.281, -0.276],
                            [0.318, -0.004],
                            [0.389, 0.313]
                          ],
                          "o": [
                            [0.693, -0.865],
                            [0.797, -0.5],
                            [0.844, -0.163],
                            [0.865, 0.163],
                            [0.863, 0.481],
                            [0.541, 0.645],
                            [0.217, 0.729],
                            [-0.105, 0.76],
                            [-0.373, 0.622],
                            [-0.42, 0.397],
                            [-0.463, 0.213],
                            [-0.518, 0.035],
                            [0.902, 0.996],
                            [0.098, 1.064],
                            [-0.586, 0.973],
                            [-0.797, 0.556],
                            [-0.896, 0.18],
                            [-0.932, -0.171],
                            [-0.941, -0.525],
                            [-0.564, -0.615],
                            [-0.252, -0.729],
                            [0.023, -0.842],
                            [0, 0],
                            [0.469, 0.044],
                            [0.279, 0.257],
                            [-0.035, 0.403],
                            [0, 0.41],
                            [0.115, 0.384],
                            [0.262, 0.343],
                            [0.545, 0.304],
                            [0.518, 0.041],
                            [0.451, -0.145],
                            [0.354, -0.29],
                            [0.283, -0.469],
                            [0.135, -0.437],
                            [-0.141, -0.438],
                            [-0.473, -0.468],
                            [0, 0],
                            [0.791, 0.43],
                            [0.605, 0.145],
                            [0.463, -0.085],
                            [0.336, -0.293],
                            [0.555, -0.919],
                            [-0.203, -0.752],
                            [-0.381, -0.213],
                            [-0.387, -0.065],
                            [-0.377, 0.061],
                            [-0.336, 0.174],
                            [-0.396, 0.333],
                            [-0.318, 0.002],
                            [0, 0]
                          ],
                          "v": [
                            [145.343, 165.032],
                            [147.581, 162.984],
                            [150.04, 161.992],
                            [152.603, 161.994],
                            [155.146, 162.933],
                            [157.253, 164.623],
                            [158.394, 166.684],
                            [158.562, 168.918],
                            [157.759, 171.124],
                            [156.57, 172.654],
                            [155.247, 173.568],
                            [153.777, 173.941],
                            [152.152, 173.848],
                            [153.65, 176.939],
                            [152.761, 180.254],
                            [150.687, 182.545],
                            [148.152, 183.65],
                            [145.413, 183.668],
                            [142.72, 182.689],
                            [140.46, 180.979],
                            [139.236, 178.959],
                            [138.89, 176.601],
                            [139.292, 173.864],
                            [141.074, 174.044],
                            [142.193, 174.498],
                            [142.57, 175.438],
                            [142.521, 176.656],
                            [142.695, 177.846],
                            [143.257, 178.938],
                            [144.374, 179.857],
                            [145.968, 180.375],
                            [147.421, 180.219],
                            [148.628, 179.565],
                            [149.493, 178.576],
                            [150.12, 177.22],
                            [150.117, 175.907],
                            [149.195, 174.546],
                            [147.058, 173.048],
                            [148.492, 170.67],
                            [150.587, 171.531],
                            [152.187, 171.619],
                            [153.388, 171.052],
                            [154.284, 169.964],
                            [154.808, 167.457],
                            [153.271, 165.643],
                            [152.118, 165.226],
                            [150.97, 165.218],
                            [149.902, 165.57],
                            [148.976, 166.245],
                            [147.902, 166.748],
                            [146.841, 166.282]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 20",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 20,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [-0.08, -0.316],
                            [0.201, -0.334],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [-0.24, 0.197],
                            [-0.318, 0.088],
                            [0, 0],
                            [-0.652, 0.25],
                            [-0.521, 0.311],
                            [-0.414, 0.389],
                            [-0.309, 0.514],
                            [-0.084, 0.428],
                            [0.092, 0.377],
                            [0.26, 0.307],
                            [0.414, 0.231],
                            [0.393, 0.068],
                            [0.373, -0.062],
                            [0.336, -0.175],
                            [0.281, -0.275],
                            [0.316, -0.005],
                            [0.396, 0.318],
                            [0, 0],
                            [-0.797, 0.501],
                            [-0.842, 0.163],
                            [-0.865, -0.164],
                            [-0.83, -0.463],
                            [-0.557, -0.665],
                            [-0.217, -0.771],
                            [0.129, -0.843],
                            [0.504, -0.838],
                            [0.572, -0.5],
                            [0.68, -0.367],
                            [0.773, -0.267],
                            [0.828, -0.261],
                            [0, 0],
                            [-0.443, -0.156],
                            [-0.363, -0.203]
                          ],
                          "o": [
                            [0.346, 0.192],
                            [0.08, 0.316],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0.135, -0.226],
                            [0.24, -0.197],
                            [0, 0],
                            [0.777, -0.24],
                            [0.652, -0.25],
                            [0.523, -0.311],
                            [0.414, -0.389],
                            [0.283, -0.468],
                            [0.084, -0.429],
                            [-0.09, -0.375],
                            [-0.26, -0.307],
                            [-0.381, -0.212],
                            [-0.391, -0.067],
                            [-0.373, 0.064],
                            [-0.336, 0.174],
                            [-0.398, 0.333],
                            [-0.314, 0.005],
                            [0, 0],
                            [0.693, -0.865],
                            [0.799, -0.499],
                            [0.844, -0.162],
                            [0.865, 0.164],
                            [0.863, 0.482],
                            [0.559, 0.666],
                            [0.217, 0.771],
                            [-0.127, 0.844],
                            [-0.434, 0.721],
                            [-0.572, 0.499],
                            [-0.678, 0.369],
                            [-0.773, 0.268],
                            [0, 0],
                            [0.482, 0.1],
                            [0.441, 0.157],
                            [0, 0]
                          ],
                          "v": [
                            [78.665, 143.651],
                            [79.306, 144.414],
                            [79.126, 145.389],
                            [77.921, 147.389],
                            [65.062, 140.219],
                            [65.73, 139.111],
                            [66.292, 138.478],
                            [67.13, 138.051],
                            [76.406, 135.277],
                            [78.552, 134.543],
                            [80.314, 133.701],
                            [81.718, 132.652],
                            [82.802, 131.297],
                            [83.353, 129.953],
                            [83.343, 128.746],
                            [82.818, 127.723],
                            [81.808, 126.915],
                            [80.648, 126.494],
                            [79.501, 126.486],
                            [78.439, 126.843],
                            [77.513, 127.518],
                            [76.445, 128.024],
                            [75.378, 127.555],
                            [73.88, 126.305],
                            [76.117, 124.257],
                            [78.577, 123.264],
                            [81.14, 123.266],
                            [83.683, 124.205],
                            [85.814, 125.926],
                            [86.976, 128.081],
                            [87.109, 130.502],
                            [86.161, 133.025],
                            [84.65, 134.856],
                            [82.775, 136.156],
                            [80.599, 137.109],
                            [78.199, 137.902],
                            [71.261, 140.047],
                            [72.65, 140.432],
                            [73.857, 140.971]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 21",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 21,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [-0.312, 0.463],
                            [0, 0],
                            [0.172, 0.054],
                            [0.117, 0.102],
                            [0.064, 0.125],
                            [0.002, 0.11],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0.271, -0.45],
                            [0, 0],
                            [-0.23, 0.04],
                            [-0.17, -0.053],
                            [-0.119, -0.101],
                            [-0.062, -0.125],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [9.142, 104.347],
                            [7.634, 106.847],
                            [-2.737, 101.064],
                            [-1.229, 98.564],
                            [2.57, 100.683],
                            [9.435, 89.29],
                            [10.312, 87.92],
                            [6.199, 88.769],
                            [5.595, 88.748],
                            [5.165, 88.517],
                            [4.892, 88.176],
                            [4.794, 87.823],
                            [4.654, 85.814],
                            [13.425, 83.932],
                            [16.056, 85.399],
                            [5.771, 102.468]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 22",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 22,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [-0.447, -0.156],
                            [0, 0],
                            [-0.204, 0.339],
                            [0, 0],
                            [0.447, 0.156],
                            [0, 0],
                            [0.204, -0.339],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0.354, 0.123],
                            [0, 0],
                            [0.258, -0.428],
                            [0, 0],
                            [-0.354, -0.123],
                            [0, 0],
                            [-0.258, 0.428]
                          ],
                          "v": [
                            [-113.694, 71.632],
                            [-108.726, 73.364],
                            [-107.758, 72.991],
                            [-107.499, 72.561],
                            [-107.86, 71.447],
                            [-112.829, 69.715],
                            [-113.796, 70.088],
                            [-114.055, 70.518]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [-0.447, -0.156],
                            [0, 0],
                            [-0.204, 0.339],
                            [0, 0],
                            [0.447, 0.156],
                            [0, 0],
                            [0.204, -0.339],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0.354, 0.123],
                            [0, 0],
                            [0.258, -0.428],
                            [0, 0],
                            [-0.354, -0.123],
                            [0, 0],
                            [-0.258, 0.428]
                          ],
                          "v": [
                            [-111.621, 68.192],
                            [-106.653, 69.925],
                            [-105.686, 69.551],
                            [-101.982, 63.405],
                            [-102.343, 62.291],
                            [-107.311, 60.559],
                            [-108.279, 60.933],
                            [-111.982, 67.079]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.363, 0.295],
                            [0, 0],
                            [-0.204, 0.339],
                            [0, 0],
                            [-0.363, -0.295],
                            [0, 0],
                            [0.204, -0.339],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [-0.287, -0.234],
                            [0, 0],
                            [0.258, -0.428],
                            [0, 0],
                            [0.287, 0.234],
                            [0, 0],
                            [-0.258, 0.428]
                          ],
                          "v": [
                            [-116.783, 69.91],
                            [-120.815, 66.624],
                            [-120.959, 65.631],
                            [-120.7, 65.201],
                            [-119.516, 64.949],
                            [-115.483, 68.235],
                            [-115.339, 69.228],
                            [-115.598, 69.658]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 3",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 3,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.363, 0.295],
                            [0, 0],
                            [-0.204, 0.339],
                            [0, 0],
                            [-0.363, -0.295],
                            [0, 0],
                            [0.204, -0.339],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [-0.287, -0.234],
                            [0, 0],
                            [0.258, -0.428],
                            [0, 0],
                            [0.287, 0.234],
                            [0, 0],
                            [-0.258, 0.428]
                          ],
                          "v": [
                            [-114.71, 66.471],
                            [-118.742, 63.185],
                            [-118.886, 62.192],
                            [-115.183, 56.046],
                            [-113.998, 55.794],
                            [-109.966, 59.079],
                            [-109.822, 60.072],
                            [-113.526, 66.218]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 4",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 4,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 23",
              "np": 4,
              "cix": 2,
              "bm": 0,
              "ix": 23,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-130.264, 8.929],
                            [-121.665, 13.723]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 2.613, "ix": 5 },
                      "lc": 2,
                      "lj": 1,
                      "ml": 10,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.973, -1.615],
                            [1.549, 0.863],
                            [-0.973, 1.615],
                            [-1.549, -0.863]
                          ],
                          "o": [
                            [-0.973, 1.615],
                            [-1.549, -0.863],
                            [0.973, -1.615],
                            [1.549, 0.863]
                          ],
                          "v": [
                            [-117.098, 12.363],
                            [-121.665, 13.723],
                            [-122.707, 9.236],
                            [-118.141, 7.876]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 2.613, "ix": 5 },
                      "lc": 2,
                      "lj": 1,
                      "ml": 10,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0.973, -1.615],
                            [1.549, 0.863],
                            [-0.973, 1.615],
                            [-1.549, -0.863]
                          ],
                          "o": [
                            [-0.973, 1.615],
                            [-1.549, -0.863],
                            [0.973, -1.615],
                            [1.549, 0.863]
                          ],
                          "v": [
                            [-125.697, 7.569],
                            [-130.264, 8.929],
                            [-131.306, 4.442],
                            [-126.74, 3.082]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 2.613, "ix": 5 },
                      "lc": 2,
                      "lj": 1,
                      "ml": 10,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 3",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 3,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 24",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 24,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ty": "gr",
                      "it": [
                        {
                          "ind": 0,
                          "ty": "sh",
                          "ix": 1,
                          "ks": {
                            "a": 0,
                            "k": {
                              "i": [
                                [0, 0],
                                [0, 0]
                              ],
                              "o": [
                                [0, 0],
                                [0, 0]
                              ],
                              "v": [
                                [-145.737, 135.817],
                                [-151.101, 144.719]
                              ],
                              "c": false
                            },
                            "ix": 2
                          },
                          "nm": "Path 1",
                          "mn": "ADBE Vector Shape - Group",
                          "hd": false
                        },
                        {
                          "ty": "st",
                          "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                          "o": { "a": 0, "k": 100, "ix": 4 },
                          "w": { "a": 0, "k": 2.147, "ix": 5 },
                          "lc": 2,
                          "lj": 1,
                          "ml": 10,
                          "bm": 0,
                          "nm": "Stroke 1",
                          "mn": "ADBE Vector Graphic - Stroke",
                          "hd": false
                        },
                        {
                          "ty": "tr",
                          "p": { "a": 0, "k": [0, 0], "ix": 2 },
                          "a": { "a": 0, "k": [0, 0], "ix": 1 },
                          "s": { "a": 0, "k": [100, 100], "ix": 3 },
                          "r": { "a": 0, "k": 0, "ix": 6 },
                          "o": { "a": 0, "k": 100, "ix": 7 },
                          "sk": { "a": 0, "k": 0, "ix": 4 },
                          "sa": { "a": 0, "k": 0, "ix": 5 },
                          "nm": "Transform"
                        }
                      ],
                      "nm": "Group 1",
                      "np": 2,
                      "cix": 2,
                      "bm": 0,
                      "ix": 1,
                      "mn": "ADBE Vector Group",
                      "hd": false
                    },
                    {
                      "ty": "gr",
                      "it": [
                        {
                          "ind": 0,
                          "ty": "sh",
                          "ix": 1,
                          "ks": {
                            "a": 0,
                            "k": {
                              "i": [
                                [0, 0],
                                [0, 0]
                              ],
                              "o": [
                                [0, 0],
                                [0, 0]
                              ],
                              "v": [
                                [-152.688, 137.888],
                                [-144.149, 142.648]
                              ],
                              "c": false
                            },
                            "ix": 2
                          },
                          "nm": "Path 1",
                          "mn": "ADBE Vector Shape - Group",
                          "hd": false
                        },
                        {
                          "ty": "st",
                          "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                          "o": { "a": 0, "k": 100, "ix": 4 },
                          "w": { "a": 0, "k": 2.147, "ix": 5 },
                          "lc": 2,
                          "lj": 1,
                          "ml": 10,
                          "bm": 0,
                          "nm": "Stroke 1",
                          "mn": "ADBE Vector Graphic - Stroke",
                          "hd": false
                        },
                        {
                          "ty": "tr",
                          "p": { "a": 0, "k": [0, 0], "ix": 2 },
                          "a": { "a": 0, "k": [0, 0], "ix": 1 },
                          "s": { "a": 0, "k": [100, 100], "ix": 3 },
                          "r": { "a": 0, "k": 0, "ix": 6 },
                          "o": { "a": 0, "k": 100, "ix": 7 },
                          "sk": { "a": 0, "k": 0, "ix": 4 },
                          "sa": { "a": 0, "k": 0, "ix": 5 },
                          "nm": "Transform"
                        }
                      ],
                      "nm": "Group 2",
                      "np": 2,
                      "cix": 2,
                      "bm": 0,
                      "ix": 2,
                      "mn": "ADBE Vector Group",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-236.075, 91.4],
                            [-228.306, 95.732]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 2.147, "ix": 5 },
                      "lc": 2,
                      "lj": 1,
                      "ml": 10,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 25",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 25,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0.205, 0.373],
                            [0, 0],
                            [0, 0],
                            [-0.438, 0.014],
                            [0, 0],
                            [0, 0],
                            [0.233, -0.387]
                          ],
                          "o": [
                            [0, 0],
                            [-0.233, 0.387],
                            [0, 0],
                            [0, 0],
                            [-0.205, -0.373],
                            [0, 0],
                            [0, 0],
                            [0.438, -0.014],
                            [0, 0]
                          ],
                          "v": [
                            [-11.814, -30.307],
                            [-13.25, -27.923],
                            [-14.236, -27.891],
                            [-15.498, -30.187],
                            [-16.76, -32.482],
                            [-16.235, -33.353],
                            [-13.537, -33.441],
                            [-10.839, -33.529],
                            [-10.378, -32.69]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [-1.387, 2.302],
                            [2.442, 1.361],
                            [0, 0]
                          ],
                          "o": [
                            [2.323, 0.835],
                            [1.534, -2.545],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-14.63, -19.654],
                            [-8.152, -22.127],
                            [-9.796, -29.2],
                            [-13.306, -31.157]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 2.613, "ix": 5 },
                      "lc": 2,
                      "lj": 1,
                      "ml": 10,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 26",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 26,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 26,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [8.31, -13.351],
                    [1.048, 7.642],
                    [1.397, 10.385],
                    [0, 0],
                    [1.805, -2.779],
                    [0, 0],
                    [37.537, -65.577],
                    [0.215, -4.668],
                    [0, 0],
                    [6.449, -10.758],
                    [0, 0],
                    [13.472, 2.875],
                    [2.086, 1.359]
                  ],
                  "o": [
                    [-8.31, 13.351],
                    [-1.074, -7.829],
                    [0, 0],
                    [-0.862, -6.623],
                    [0, 0],
                    [-55.403, 85.565],
                    [-2.321, 4.056],
                    [0, 0],
                    [-0.578, 12.53],
                    [0, 0],
                    [-14.983, 24.954],
                    [-3.079, -0.657],
                    [0, 0]
                  ],
                  "v": [
                    [-121.498, -280.07],
                    [-135.074, -283.8],
                    [-139.61, -317.332],
                    [-139.737, -318.279],
                    [-145.747, -320.762],
                    [-146.897, -318.985],
                    [-284.899, -92.607],
                    [-288.759, -79.339],
                    [-291.77, -14.02],
                    [-302.476, 21.457],
                    [-342.86, 88.697],
                    [-392.286, 129.567],
                    [-400.009, 126.492]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5.35, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [9.642, 5.425],
                    [0, 0],
                    [11.555, -16.612],
                    [36.905, -71.07],
                    [0.113, -0.215],
                    [-21.664, -12.15],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [-0.631, -10.164],
                    [0, 0],
                    [-17.636, -9.923],
                    [-177.688, 255.443],
                    [0, 0],
                    [-6.763, 12.872],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-50.226, -496.054],
                    [-66.076, -521.354],
                    [-158.013, -572.967],
                    [-209.48, -561.147],
                    [-544.487, -11.081],
                    [-550.146, -0.268],
                    [-544.934, 44.519],
                    [-548.556, 42.471],
                    [-398.602, 127.259]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5.35, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-6.52, 10.864],
                    [0, 0],
                    [9.352, 8.189]
                  ],
                  "o": [
                    [11.558, 4.082],
                    [0, 0],
                    [6.656, -11.091],
                    [0, 0]
                  ],
                  "v": [
                    [-373.049, 123.376],
                    [-341.805, 112.112],
                    [-286.626, 20.171],
                    [-291.818, -13.092]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 6",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-6.585, -3.802],
                    [-0.672, -5.119]
                  ],
                  "o": [
                    [4.773, -2.168],
                    [6.424, 3.709],
                    [0, 0]
                  ],
                  "v": [
                    [-501.548, 69.05],
                    [-483.031, 71.411],
                    [-471.773, 85.883]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 7",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [16.63, -24.855]
                  ],
                  "o": [
                    [-17.782, 25.591],
                    [0, 0]
                  ],
                  "v": [
                    [-114.61, -548.6],
                    [-158.576, -484.869]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            { "ty": "mm", "mm": 4, "nm": "Merge Paths 1", "mn": "ADBE Vector Filter - Merge", "hd": false },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 8.916, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 8",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-26.431, -371.681],
                    [-26.431, -308.892]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5.35, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 9",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [-8.937, 14.929],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [15.158, 8.543],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-177.166, -271.862],
                        [-155.048, -259.396],
                        [-111.748, -270.872],
                        [-89.627, -307.821]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [26.686, -43.816],
                            [0, 0],
                            [10.105, 5.636],
                            [0, 0]
                          ],
                          "o": [
                            [3.494, 38.483],
                            [0, 0],
                            [-5.934, 9.934],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [-50.226, -496.054],
                            [-83.266, -344.27],
                            [-121.498, -280.07],
                            [-150.293, -272.355],
                            [-168.88, -282.722]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.35, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 10",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 10,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [-14.02, -7.901],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 16.093],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-584.526, 52.706],
                        [-584.526, 75.814],
                        [-561.833, 114.651],
                        [-553.232, 119.499]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 5.35, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [-11.185, 18.63],
                        [0, 0],
                        [0, 9.701],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [18.93, 10.669],
                        [0, 0],
                        [4.994, -8.317],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-534.984, 129.783],
                        [207.193, 548.064],
                        [261.292, 533.763],
                        [470.641, 185.079],
                        [478.273, 157.542],
                        [478.273, 139.66]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 5.35, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 11",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 11,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-551.788, 96.004],
                        [-532.156, 107.076]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [-11.188, 18.634],
                        [0, 0],
                        [-0.184, 5.878]
                      ],
                      "o": [
                        [0, 0],
                        [18.931, 10.677],
                        [0, 0],
                        [3.248, -5.41],
                        [0, 0]
                      ],
                      "v": [
                        [-514.972, 116.768],
                        [207.189, 524.059],
                        [261.298, 509.765],
                        [473.178, 156.864],
                        [478.255, 139.659]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [12, 6.76]
                      ],
                      "o": [
                        [0.402, -12.828],
                        [0, 0]
                      ],
                      "v": [
                        [478.255, 139.659],
                        [460.107, 107.433]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 5.35, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [17.498, 9.858],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [460.107, 107.433],
                        [449.164, 101.268]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 12",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 12,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [-0.494, 14.467]
                      ],
                      "o": [
                        [0, 0],
                        [-13.53, -7.626],
                        [0, 0]
                      ],
                      "v": [
                        [-551.788, 96.004],
                        [-564.096, 89.067],
                        [-584.503, 52.706]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-3.634, 6.053],
                        [0, 0],
                        [-6.699, 3.813]
                      ],
                      "o": [
                        [0.224, -6.576],
                        [0, 0],
                        [4.242, -7.066],
                        [0, 0]
                      ],
                      "v": [
                        [-584.503, 52.706],
                        [-578.795, 33.461],
                        [-270.572, -479.921],
                        [-253.795, -496.336]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 5.35, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0.44, -12.858]
                      ],
                      "o": [
                        [0, 0],
                        [12.024, 6.78],
                        [0, 0]
                      ],
                      "v": [
                        [-57.289, -411.433],
                        [-44.552, -404.251],
                        [-26.42, -371.931]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 5.35, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [3.23, -5.379],
                        [0, 0],
                        [20.614, 11.626],
                        [0, 0]
                      ],
                      "o": [
                        [-0.2, 5.844],
                        [0, 0],
                        [-12.182, 20.291],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-26.42, -371.931],
                        [-31.493, -354.827],
                        [-343.42, 164.725],
                        [-402.34, 180.291],
                        [-427.651, 166.016]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 13",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 13,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [5.41, -9.011],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 10.51],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [612.751, -179.982],
                    [612.751, -163.094],
                    [604.484, -133.261],
                    [460.107, 107.433]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 5.35, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 14",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 14,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-535.352, -45.977],
                    [-197.76, -608.925],
                    [-197.692, -506.211]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 15",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 15,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-535.352, 57.213],
                    [-377.129, 145.678],
                    [-377.129, 43.032],
                    [-39.536, -519.915]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 16",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 16,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [232.728, 528.631],
                    [232.728, 551.776]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 17",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 17,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [18.908, -31.463],
                    [68.867, 38.779],
                    [65.317, 36.456]
                  ],
                  "o": [
                    [-18.561, 30.887],
                    [-118.299, -66.615],
                    [-62.067, -34.642]
                  ],
                  "v": [
                    [449.164, 101.268],
                    [311.612, 89.605],
                    [107.741, 78.926]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 18",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 18,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [17.397, -28.976],
                    [-93.338, -51.761],
                    [-71.263, -40.481]
                  ],
                  "o": [
                    [-12.105, 20.162],
                    [131.788, 73.084],
                    [84.921, 48.24]
                  ],
                  "v": [
                    [-90.285, -202.539],
                    [-10.87, -93.134],
                    [107.741, 78.926]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 19",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 19,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [10.218, -17.167],
                            [-24.37, -13.832],
                            [-8.428, 0],
                            [-10.302, 17.307],
                            [24.551, 13.53],
                            [8.377, -0.001]
                          ],
                          "o": [
                            [-18.524, 0.002],
                            [-14.839, 24.93],
                            [7.654, 4.345],
                            [18.406, 0],
                            [15.02, -25.233],
                            [-7.645, -4.213],
                            [0, 0]
                          ],
                          "v": [
                            [142.147, -28.322],
                            [94.936, -1.385],
                            [112.265, 69.092],
                            [136.776, 75.496],
                            [183.883, 48.364],
                            [166.554, -22.113],
                            [142.147, -28.322]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ind": 1,
                      "ty": "sh",
                      "ix": 2,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0],
                            [0, 0],
                            [-5.662, -3.12],
                            [-2.648, -9.754],
                            [5.885, -9.886],
                            [15.03, 0],
                            [5.641, 3.202],
                            [2.625, 9.914],
                            [-5.748, 9.657],
                            [-15.167, 0.001],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0],
                            [6.642, 0],
                            [8.708, 4.799],
                            [2.889, 10.64],
                            [-7.883, 13.243],
                            [-6.652, 0],
                            [-8.764, -4.974],
                            [-2.801, -10.578],
                            [7.81, -13.121],
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [142.151, -28.322],
                            [142.151, -16.731],
                            [142.151, -16.731],
                            [160.959, -11.962],
                            [178.569, 10.606],
                            [173.923, 42.436],
                            [136.776, 63.905],
                            [117.986, 59.012],
                            [100.325, 35.923],
                            [104.896, 4.544],
                            [142.148, -16.731],
                            [142.151, -28.322]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 2",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "fl",
                      "c": { "a": 0, "k": [0.262745112181, 0.658823549747, 0.780392169952, 1], "ix": 4 },
                      "o": { "a": 0, "k": 100, "ix": 5 },
                      "r": 1,
                      "bm": 0,
                      "nm": "Fill 1",
                      "mn": "ADBE Vector Graphic - Fill",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 3,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 20",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 20,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [89.209, -391.253],
                    [121.922, -372.816]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 21",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 21,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-1.3, 2.149],
                        [0, 0],
                        [-2.518, -1.419],
                        [0, 0],
                        [1.292, -2.152],
                        [0, 0],
                        [2.525, 1.432],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [1.496, -2.473],
                        [0, 0],
                        [2.187, 1.232],
                        [0, 0],
                        [-1.494, 2.488],
                        [0, 0],
                        [-2.185, -1.239]
                      ],
                      "v": [
                        [75.401, -391.248],
                        [82.208, -402.499],
                        [89.411, -404.39],
                        [124.015, -384.887],
                        [125.648, -378.709],
                        [118.828, -367.351],
                        [111.603, -365.451],
                        [77.017, -385.062]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 22",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 22,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [69.496, -358.371],
                    [102.208, -339.934]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 23",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 23,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-2.524, -1.423],
                        [0, 0],
                        [1.292, -2.152],
                        [0, 0],
                        [2.524, 1.423],
                        [0, 0],
                        [-1.292, 2.152],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [2.187, 1.232],
                        [0, 0],
                        [-1.491, 2.484],
                        [0, 0],
                        [-2.187, -1.232],
                        [0, 0],
                        [1.491, -2.484]
                      ],
                      "v": [
                        [69.713, -371.5],
                        [104.302, -352.006],
                        [105.935, -345.827],
                        [99.108, -334.458],
                        [91.895, -332.551],
                        [57.307, -352.045],
                        [55.673, -358.224],
                        [62.5, -369.593]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 24",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 24,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [49.782, -325.489],
                    [82.495, -307.052]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 25",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 25,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-2.524, -1.423],
                        [0, 0],
                        [1.292, -2.152],
                        [0, 0],
                        [2.524, 1.423],
                        [0, 0],
                        [-1.292, 2.152],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [2.187, 1.232],
                        [0, 0],
                        [-1.491, 2.484],
                        [0, 0],
                        [-2.187, -1.232],
                        [0, 0],
                        [1.491, -2.484]
                      ],
                      "v": [
                        [50, -338.618],
                        [84.588, -319.124],
                        [86.222, -312.945],
                        [79.395, -301.576],
                        [72.182, -299.669],
                        [37.593, -319.163],
                        [35.96, -325.342],
                        [42.787, -336.711]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 26",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 26,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [30.069, -292.607],
                    [62.782, -274.17]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 27",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 27,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-2.524, -1.423],
                        [0, 0],
                        [1.292, -2.152],
                        [0, 0],
                        [2.524, 1.423],
                        [0, 0],
                        [-1.292, 2.152],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [2.187, 1.232],
                        [0, 0],
                        [-1.491, 2.484],
                        [0, 0],
                        [-2.187, -1.232],
                        [0, 0],
                        [1.491, -2.484]
                      ],
                      "v": [
                        [30.287, -305.736],
                        [64.875, -286.242],
                        [66.508, -280.064],
                        [59.682, -268.694],
                        [52.468, -266.787],
                        [17.88, -286.281],
                        [16.247, -292.46],
                        [23.074, -303.83]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 28",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 28,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [10.356, -259.726],
                    [43.069, -241.289]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 29",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 29,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [-2.524, -1.423],
                        [0, 0],
                        [1.292, -2.152],
                        [0, 0],
                        [2.524, 1.423],
                        [0, 0],
                        [-1.292, 2.152],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [2.187, 1.232],
                        [0, 0],
                        [-1.491, 2.484],
                        [0, 0],
                        [-2.187, -1.232],
                        [0, 0],
                        [1.491, -2.484]
                      ],
                      "v": [
                        [10.574, -272.855],
                        [45.162, -253.361],
                        [46.795, -247.182],
                        [39.968, -235.812],
                        [32.755, -233.906],
                        [-1.833, -253.4],
                        [-3.466, -259.578],
                        [3.361, -270.948]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 30",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 30,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [515.843, -150.977],
                        [548.556, -132.54]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [-2.524, -1.423],
                            [0, 0],
                            [1.551, -2.582],
                            [0, 0],
                            [2.524, 1.423],
                            [0, 0],
                            [-1.551, 2.582],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [2.624, 1.479],
                            [0, 0],
                            [-1.491, 2.484],
                            [0, 0],
                            [-2.624, -1.479],
                            [0, 0],
                            [1.491, -2.484]
                          ],
                          "v": [
                            [526.309, -158.302],
                            [560.099, -139.258],
                            [562.059, -131.844],
                            [555.704, -121.26],
                            [548.491, -119.353],
                            [514.701, -138.397],
                            [512.741, -145.812],
                            [519.096, -156.396]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 3.566, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 31",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 31,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [496.13, -118.096],
                        [528.842, -99.659]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [-2.524, -1.423],
                            [0, 0],
                            [1.551, -2.582],
                            [0, 0],
                            [2.524, 1.423],
                            [0, 0],
                            [-1.551, 2.582],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [2.624, 1.479],
                            [0, 0],
                            [-1.491, 2.484],
                            [0, 0],
                            [-2.624, -1.479],
                            [0, 0],
                            [1.491, -2.484]
                          ],
                          "v": [
                            [506.596, -125.42],
                            [540.386, -106.376],
                            [542.346, -98.962],
                            [535.991, -88.378],
                            [528.778, -86.472],
                            [494.988, -105.516],
                            [493.028, -112.93],
                            [499.383, -123.514]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 3.566, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 32",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 32,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [476.416, -85.214],
                        [509.129, -66.777]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [-2.524, -1.423],
                            [0, 0],
                            [1.551, -2.582],
                            [0, 0],
                            [2.524, 1.423],
                            [0, 0],
                            [-1.551, 2.582],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [2.624, 1.479],
                            [0, 0],
                            [-1.491, 2.484],
                            [0, 0],
                            [-2.624, -1.479],
                            [0, 0],
                            [1.491, -2.484]
                          ],
                          "v": [
                            [486.883, -92.539],
                            [520.673, -73.495],
                            [522.632, -66.08],
                            [516.277, -55.496],
                            [509.064, -53.59],
                            [475.274, -72.634],
                            [473.315, -80.048],
                            [479.67, -90.632]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 3.566, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 33",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 33,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [456.703, -52.332],
                        [489.416, -33.895]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [-2.524, -1.423],
                            [0, 0],
                            [1.551, -2.582],
                            [0, 0],
                            [2.524, 1.423],
                            [0, 0],
                            [-1.551, 2.582],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [2.624, 1.479],
                            [0, 0],
                            [-1.491, 2.484],
                            [0, 0],
                            [-2.624, -1.479],
                            [0, 0],
                            [1.491, -2.484]
                          ],
                          "v": [
                            [467.17, -59.657],
                            [500.959, -40.613],
                            [502.919, -33.199],
                            [496.564, -22.615],
                            [489.351, -20.708],
                            [455.561, -39.752],
                            [453.602, -47.167],
                            [459.956, -57.75]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 3.566, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 34",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 34,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [436.99, -19.45],
                        [469.703, -1.013]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [-2.524, -1.423],
                            [0, 0],
                            [1.551, -2.582],
                            [0, 0],
                            [2.524, 1.423],
                            [0, 0],
                            [-1.551, 2.582],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [2.624, 1.479],
                            [0, 0],
                            [-1.491, 2.484],
                            [0, 0],
                            [-2.624, -1.479],
                            [0, 0],
                            [1.491, -2.484]
                          ],
                          "v": [
                            [447.456, -26.775],
                            [481.246, -7.731],
                            [483.206, -0.317],
                            [476.851, 10.267],
                            [469.638, 12.174],
                            [435.848, -6.87],
                            [433.888, -14.285],
                            [440.243, -24.869]
                          ],
                          "c": true
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 3.566, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 1,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 35",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 35,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.809, 3.013],
                    [0, 0],
                    [-3.365, -1.897],
                    [0, 0],
                    [1.809, -3.013],
                    [0, 0],
                    [3.365, 1.897],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.989, -3.312],
                    [0, 0],
                    [3.061, 1.725],
                    [0, 0],
                    [-1.989, 3.312],
                    [0, 0],
                    [-3.061, -1.725]
                  ],
                  "v": [
                    [231.179, -53.193],
                    [236.17, -61.504],
                    [245.787, -64.046],
                    [277.267, -46.304],
                    [279.554, -37.654],
                    [274.563, -29.343],
                    [264.946, -26.801],
                    [233.466, -44.543]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 36",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 36,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.809, 3.013],
                    [0, 0],
                    [-3.365, -1.897],
                    [0, 0],
                    [1.809, -3.013],
                    [0, 0],
                    [3.365, 1.897],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.989, -3.312],
                    [0, 0],
                    [3.061, 1.725],
                    [0, 0],
                    [-1.989, 3.312],
                    [0, 0],
                    [-3.061, -1.725]
                  ],
                  "v": [
                    [130.291, -110.139],
                    [135.281, -118.449],
                    [144.899, -120.992],
                    [176.379, -103.249],
                    [178.665, -94.599],
                    [173.675, -86.288],
                    [164.058, -83.746],
                    [132.578, -101.489]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 37",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 37,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [4.206, 2.362],
                        [0, 0],
                        [-3.104, 5.17],
                        [0, 0],
                        [-4.207, -2.372],
                        [0, 0],
                        [3.101, -5.164],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-5.258, -2.953],
                        [0, 0],
                        [2.486, -4.14],
                        [0, 0],
                        [5.247, 2.959],
                        [0, 0],
                        [-2.483, 4.135]
                      ],
                      "v": [
                        [-80.529, 264.383],
                        [-106.526, 249.783],
                        [-110.46, 234.946],
                        [-98.802, 215.531],
                        [-86.779, 212.355],
                        [-60.805, 227],
                        [-56.887, 241.828],
                        [-68.519, 261.199]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 38",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 38,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [4.206, 2.362],
                        [0, 0],
                        [-3.104, 5.17],
                        [0, 0],
                        [-4.207, -2.372],
                        [0, 0],
                        [3.101, -5.164],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-5.258, -2.953],
                        [0, 0],
                        [2.486, -4.14],
                        [0, 0],
                        [5.247, 2.959],
                        [0, 0],
                        [-2.483, 4.135]
                      ],
                      "v": [
                        [-51.443, 215.97],
                        [-77.441, 201.369],
                        [-81.374, 186.533],
                        [-69.717, 167.118],
                        [-57.694, 163.941],
                        [-31.72, 178.587],
                        [-27.802, 193.414],
                        [-39.433, 212.785]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 39",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 39,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [4.206, 2.362],
                        [0, 0],
                        [-3.104, 5.17],
                        [0, 0],
                        [-4.207, -2.372],
                        [0, 0],
                        [3.101, -5.164],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-5.258, -2.953],
                        [0, 0],
                        [2.486, -4.14],
                        [0, 0],
                        [5.247, 2.959],
                        [0, 0],
                        [-2.483, 4.135]
                      ],
                      "v": [
                        [-6.181, 306.351],
                        [-32.179, 291.75],
                        [-36.113, 276.914],
                        [-24.455, 257.499],
                        [-12.432, 254.322],
                        [13.542, 268.968],
                        [17.46, 283.795],
                        [5.829, 303.167]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 40",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 40,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [4.206, 2.362],
                        [0, 0],
                        [-3.104, 5.17],
                        [0, 0],
                        [-4.207, -2.372],
                        [0, 0],
                        [3.101, -5.164],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-5.258, -2.953],
                        [0, 0],
                        [2.486, -4.14],
                        [0, 0],
                        [5.247, 2.959],
                        [0, 0],
                        [-2.483, 4.135]
                      ],
                      "v": [
                        [68.166, 348.318],
                        [42.169, 333.718],
                        [38.235, 318.881],
                        [49.892, 299.466],
                        [61.916, 296.289],
                        [87.89, 310.935],
                        [91.807, 325.763],
                        [80.176, 345.134]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 41",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 41,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [4.206, 2.362],
                        [0, 0],
                        [-3.104, 5.17],
                        [0, 0],
                        [-4.207, -2.372],
                        [0, 0],
                        [3.101, -5.164],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-5.258, -2.953],
                        [0, 0],
                        [2.486, -4.14],
                        [0, 0],
                        [5.247, 2.959],
                        [0, 0],
                        [-2.483, 4.135]
                      ],
                      "v": [
                        [22.904, 257.937],
                        [-3.093, 243.337],
                        [-7.027, 228.5],
                        [4.63, 209.085],
                        [16.654, 205.908],
                        [42.628, 220.554],
                        [46.546, 235.382],
                        [34.914, 254.753]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 42",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 42,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [4.206, 2.362],
                        [0, 0],
                        [-3.104, 5.17],
                        [0, 0],
                        [-4.207, -2.372],
                        [0, 0],
                        [3.101, -5.164],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-5.258, -2.953],
                        [0, 0],
                        [2.486, -4.14],
                        [0, 0],
                        [5.247, 2.959],
                        [0, 0],
                        [-2.483, 4.135]
                      ],
                      "v": [
                        [97.252, 299.905],
                        [71.254, 285.304],
                        [67.32, 270.467],
                        [78.978, 251.052],
                        [91.001, 247.876],
                        [116.975, 262.522],
                        [120.893, 277.349],
                        [109.262, 296.72]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 43",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 43,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [4.206, 2.362],
                        [0, 0],
                        [-3.104, 5.17],
                        [0, 0],
                        [-4.207, -2.372],
                        [0, 0],
                        [3.101, -5.164],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-5.258, -2.953],
                        [0, 0],
                        [2.486, -4.14],
                        [0, 0],
                        [5.247, 2.959],
                        [0, 0],
                        [-2.483, 4.135]
                      ],
                      "v": [
                        [126.337, 251.491],
                        [100.34, 236.89],
                        [96.406, 222.054],
                        [108.063, 202.639],
                        [120.087, 199.462],
                        [146.061, 214.108],
                        [149.978, 228.936],
                        [138.347, 248.307]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 44",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 44,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [4.206, 2.362],
                        [0, 0],
                        [-3.104, 5.17],
                        [0, 0],
                        [-4.207, -2.372],
                        [0, 0],
                        [3.101, -5.164],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-5.258, -2.953],
                        [0, 0],
                        [2.486, -4.14],
                        [0, 0],
                        [5.247, 2.959],
                        [0, 0],
                        [-2.483, 4.135]
                      ],
                      "v": [
                        [-22.358, 167.556],
                        [-48.355, 152.956],
                        [-52.289, 138.119],
                        [-40.632, 118.704],
                        [-28.608, 115.527],
                        [-2.634, 130.173],
                        [1.284, 145.001],
                        [-10.348, 164.372]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 45",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 45,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [4.206, 2.362],
                        [0, 0],
                        [-3.104, 5.17],
                        [0, 0],
                        [-4.207, -2.372],
                        [0, 0],
                        [3.101, -5.164],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-5.258, -2.953],
                        [0, 0],
                        [2.486, -4.14],
                        [0, 0],
                        [5.247, 2.959],
                        [0, 0],
                        [-2.483, 4.135]
                      ],
                      "v": [
                        [51.99, 209.523],
                        [25.992, 194.923],
                        [22.058, 180.086],
                        [33.716, 160.671],
                        [45.739, 157.495],
                        [71.713, 172.14],
                        [75.631, 186.968],
                        [64, 206.339]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 46",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 46,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [-4.207, -2.372],
                        [0, 0],
                        [3.101, -5.164],
                        [0, 0],
                        [4.206, 2.362],
                        [0, 0],
                        [-3.104, 5.17]
                      ],
                      "o": [
                        [2.486, -4.14],
                        [0, 0],
                        [5.247, 2.959],
                        [0, 0],
                        [-2.483, 4.135],
                        [0, 0],
                        [-5.258, -2.953],
                        [0, 0]
                      ],
                      "v": [
                        [-11.546, 70.29],
                        [0.477, 67.113],
                        [26.451, 81.759],
                        [30.369, 96.587],
                        [18.738, 115.958],
                        [6.728, 119.142],
                        [-19.27, 104.542],
                        [-23.204, 89.705]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 47",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 47,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [4.206, 2.362],
                        [0, 0],
                        [-3.104, 5.17],
                        [0, 0],
                        [-4.207, -2.372],
                        [0, 0],
                        [3.101, -5.164],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-5.258, -2.953],
                        [0, 0],
                        [2.486, -4.14],
                        [0, 0],
                        [5.247, 2.959],
                        [0, 0],
                        [-2.483, 4.135]
                      ],
                      "v": [
                        [155.423, 203.11],
                        [129.425, 188.509],
                        [125.491, 173.672],
                        [137.149, 154.257],
                        [149.172, 151.081],
                        [175.146, 165.727],
                        [179.064, 180.554],
                        [167.433, 199.925]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 48",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 48,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [4.206, 2.362],
                        [0, 0],
                        [-3.103, 5.172],
                        [0, 0],
                        [-4.207, -2.372],
                        [0, 0],
                        [3.102, -5.162],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-5.26, -2.951],
                        [0, 0],
                        [2.486, -4.14],
                        [0, 0],
                        [5.245, 2.961],
                        [0, 0],
                        [-2.483, 4.135]
                      ],
                      "v": [
                        [81.075, 161.11],
                        [55.082, 146.53],
                        [51.141, 131.695],
                        [62.801, 112.258],
                        [74.825, 109.081],
                        [100.803, 123.748],
                        [104.714, 138.576],
                        [93.085, 157.925]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 49",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 49,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.807, 3.01],
                    [0, 0],
                    [-2.525, -1.428],
                    [0, 0],
                    [1.807, -3.01],
                    [0, 0],
                    [2.525, 1.428],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.493, -2.487],
                    [0, 0],
                    [3.055, 1.728],
                    [0, 0],
                    [-1.493, 2.487],
                    [0, 0],
                    [-3.056, -1.728]
                  ],
                  "v": [
                    [-250.235, 88.362],
                    [-245.304, 80.149],
                    [-238.083, 78.246],
                    [-133.344, 137.498],
                    [-131.066, 146.143],
                    [-135.993, 154.349],
                    [-143.213, 156.251],
                    [-247.957, 97.007]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 50",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 50,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.809, 3.013],
                    [0, 0],
                    [-2.524, -1.423],
                    [0, 0],
                    [1.809, -3.012],
                    [0, 0],
                    [2.524, 1.423],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.492, -2.484],
                    [0, 0],
                    [3.061, 1.726],
                    [0, 0],
                    [-1.491, 2.484],
                    [0, 0],
                    [-3.061, -1.725]
                  ],
                  "v": [
                    [-134.872, 56.417],
                    [-129.942, 48.206],
                    [-122.728, 46.299],
                    [-89.74, 64.9],
                    [-87.455, 73.55],
                    [-92.381, 81.754],
                    [-99.594, 83.661],
                    [-132.586, 65.067]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 51",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 51,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.809, 3.013],
                    [0, 0],
                    [-2.524, -1.423],
                    [0, 0],
                    [1.809, -3.012],
                    [0, 0],
                    [2.524, 1.423],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.492, -2.484],
                    [0, 0],
                    [3.061, 1.726],
                    [0, 0],
                    [-1.491, 2.484],
                    [0, 0],
                    [-3.061, -1.725]
                  ],
                  "v": [
                    [-206.688, 15.752],
                    [-201.758, 7.541],
                    [-194.544, 5.635],
                    [-161.556, 24.236],
                    [-159.271, 32.885],
                    [-164.197, 41.09],
                    [-171.41, 42.997],
                    [-204.402, 24.403]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 52",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 52,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.809, 3.013],
                    [0, 0],
                    [-2.524, -1.423],
                    [0, 0],
                    [1.809, -3.012],
                    [0, 0],
                    [2.524, 1.423],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.492, -2.484],
                    [0, 0],
                    [3.061, 1.726],
                    [0, 0],
                    [-1.491, 2.484],
                    [0, 0],
                    [-3.061, -1.725]
                  ],
                  "v": [
                    [-148.425, -0.012],
                    [-143.495, -8.223],
                    [-136.281, -10.129],
                    [-103.293, 8.471],
                    [-101.008, 17.121],
                    [-105.934, 25.325],
                    [-113.147, 27.232],
                    [-146.139, 8.638]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 53",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 53,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.551, 2.582],
                    [0, 0],
                    [-2.945, -1.66],
                    [0, 0],
                    [1.55, -2.582],
                    [0, 0],
                    [2.945, 1.66],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.74, -2.898],
                    [0, 0],
                    [2.623, 1.479],
                    [0, 0],
                    [-1.74, 2.898],
                    [0, 0],
                    [-2.624, -1.479]
                  ],
                  "v": [
                    [237.263, 364.486],
                    [242.219, 356.233],
                    [250.635, 354.009],
                    [283.665, 372.634],
                    [285.624, 380.048],
                    [280.672, 388.294],
                    [272.257, 390.519],
                    [239.223, 371.901]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 54",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 54,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.551, 2.582],
                    [0, 0],
                    [-2.945, -1.66],
                    [0, 0],
                    [1.55, -2.582],
                    [0, 0],
                    [2.945, 1.66],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.74, -2.898],
                    [0, 0],
                    [2.623, 1.479],
                    [0, 0],
                    [-1.74, 2.898],
                    [0, 0],
                    [-2.624, -1.479]
                  ],
                  "v": [
                    [165.447, 323.822],
                    [170.403, 315.569],
                    [178.819, 313.345],
                    [211.849, 331.97],
                    [213.808, 339.384],
                    [208.857, 347.63],
                    [200.441, 349.855],
                    [167.407, 331.237]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 55",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 55,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.551, 2.582],
                    [0, 0],
                    [-2.945, -1.66],
                    [0, 0],
                    [1.55, -2.582],
                    [0, 0],
                    [2.945, 1.66],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.74, -2.898],
                    [0, 0],
                    [2.623, 1.479],
                    [0, 0],
                    [-1.74, 2.898],
                    [0, 0],
                    [-2.624, -1.479]
                  ],
                  "v": [
                    [280.879, 291.885],
                    [285.835, 283.632],
                    [294.251, 281.408],
                    [327.281, 300.033],
                    [329.24, 307.447],
                    [324.288, 315.693],
                    [315.873, 317.918],
                    [282.839, 299.299]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 56",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 56,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.551, 2.582],
                    [0, 0],
                    [-2.945, -1.66],
                    [0, 0],
                    [1.55, -2.582],
                    [0, 0],
                    [2.945, 1.66],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.74, -2.898],
                    [0, 0],
                    [2.623, 1.479],
                    [0, 0],
                    [-1.74, 2.898],
                    [0, 0],
                    [-2.624, -1.479]
                  ],
                  "v": [
                    [209.063, 251.221],
                    [214.019, 242.968],
                    [222.435, 240.744],
                    [255.465, 259.369],
                    [257.424, 266.783],
                    [252.472, 275.029],
                    [244.057, 277.253],
                    [211.023, 258.635]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 57",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 57,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.551, 2.582],
                    [0, 0],
                    [-2.945, -1.66],
                    [0, 0],
                    [1.55, -2.582],
                    [0, 0],
                    [2.945, 1.66],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.74, -2.898],
                    [0, 0],
                    [2.623, 1.479],
                    [0, 0],
                    [-1.74, 2.898],
                    [0, 0],
                    [-2.624, -1.479]
                  ],
                  "v": [
                    [180.142, 380.666],
                    [185.097, 372.413],
                    [193.514, 370.189],
                    [226.544, 388.814],
                    [228.503, 396.228],
                    [223.551, 404.474],
                    [215.136, 406.698],
                    [182.101, 388.08]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 58",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 58,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.551, 2.582],
                    [0, 0],
                    [-2.945, -1.66],
                    [0, 0],
                    [1.55, -2.582],
                    [0, 0],
                    [2.945, 1.66],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.74, -2.898],
                    [0, 0],
                    [2.623, 1.479],
                    [0, 0],
                    [-1.74, 2.898],
                    [0, 0],
                    [-2.624, -1.479]
                  ],
                  "v": [
                    [267.326, 235.456],
                    [272.281, 227.203],
                    [280.698, 224.98],
                    [313.728, 243.604],
                    [315.687, 251.018],
                    [310.735, 259.265],
                    [302.32, 261.489],
                    [269.286, 242.871]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 59",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 59,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.551, 2.582],
                    [0, 0],
                    [-2.945, -1.66],
                    [0, 0],
                    [1.55, -2.582],
                    [0, 0],
                    [2.945, 1.66],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.74, -2.898],
                    [0, 0],
                    [2.623, 1.479],
                    [0, 0],
                    [-1.74, 2.898],
                    [0, 0],
                    [-2.624, -1.479]
                  ],
                  "v": [
                    [243.761, 125.33],
                    [248.717, 117.076],
                    [257.133, 114.853],
                    [290.163, 133.477],
                    [292.122, 140.891],
                    [287.171, 149.138],
                    [278.755, 151.362],
                    [245.721, 132.744]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 60",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 60,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.809, 3.013],
                    [0, 0],
                    [-2.524, -1.423],
                    [0, 0],
                    [1.809, -3.012],
                    [0, 0],
                    [2.524, 1.423],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.492, -2.484],
                    [0, 0],
                    [3.061, 1.726],
                    [0, 0],
                    [-1.491, 2.484],
                    [0, 0],
                    [-3.061, -1.725]
                  ],
                  "v": [
                    [-36.271, -33.879],
                    [-31.34, -42.09],
                    [-24.126, -43.996],
                    [8.861, -25.396],
                    [11.147, -16.746],
                    [6.22, -8.542],
                    [-0.993, -6.635],
                    [-33.984, -25.229]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 61",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 61,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.809, 3.013],
                    [0, 0],
                    [-3.365, -1.897],
                    [0, 0],
                    [1.809, -3.013],
                    [0, 0],
                    [3.365, 1.897],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.989, -3.312],
                    [0, 0],
                    [3.061, 1.725],
                    [0, 0],
                    [-1.989, 3.312],
                    [0, 0],
                    [-3.061, -1.725]
                  ],
                  "v": [
                    [32.389, -165.3],
                    [37.379, -173.61],
                    [46.996, -176.153],
                    [78.476, -158.41],
                    [80.763, -149.76],
                    [75.773, -141.449],
                    [66.155, -138.907],
                    [34.675, -156.65]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 62",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 62,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-1.809, 3.013],
                    [0, 0],
                    [-3.365, -1.897],
                    [0, 0],
                    [1.809, -3.013],
                    [0, 0],
                    [3.365, 1.897],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [1.989, -3.312],
                    [0, 0],
                    [3.061, 1.725],
                    [0, 0],
                    [-1.989, 3.312],
                    [0, 0],
                    [-3.061, -1.725]
                  ],
                  "v": [
                    [330.238, 2.57],
                    [335.228, -5.741],
                    [344.846, -8.283],
                    [376.326, 9.459],
                    [378.612, 18.109],
                    [373.622, 26.42],
                    [364.005, 28.962],
                    [332.525, 11.22]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 63",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 63,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [48.062, -205.018],
                        [155.551, -384.036],
                        [509.753, -184.304],
                        [402.264, -5.286]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 64",
          "np": 1,
          "cix": 2,
          "bm": 0,
          "ix": 64,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [11.531, 6.499],
                        [0, 0],
                        [9.943, -16.56],
                        [0, 0]
                      ],
                      "o": [
                        [-0.129, -12.306],
                        [0, 0],
                        [-16.827, -9.484],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [612.767, -181.435],
                        [594.609, -212.166],
                        [117.425, -481.108],
                        [69.337, -468.397],
                        [-26.431, -308.892]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 5.35, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0.067, 6.363]
                      ],
                      "o": [
                        [0, 0],
                        [3.523, -5.868],
                        [0, 0]
                      ],
                      "v": [
                        [604.48, -157.417],
                        [607.675, -162.738],
                        [612.767, -181.435]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-26.431, -308.892],
                        [-90.285, -202.539]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 3.566, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 65",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 65,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-114.671, -216.283],
                    [11.992, -144.895]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 66",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 66,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [11.992, -144.895],
                    [12.009, -144.886],
                    [449.164, 101.268]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 67",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 67,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-333.188, 97.71],
                    [-300.404, 43.124]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.40000000596, 0.176470592618, 0.568627476692, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2.675, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 68",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 68,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-102.576, -286.262],
                    [-35.846, -397.368]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 69",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 69,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-4.647, 9.05],
                    [-191.29, 274.777],
                    [0.419, 6.745]
                  ],
                  "o": [
                    [-9.039, -5.89],
                    [27.51, -53.571],
                    [4.195, -6.026],
                    [0, 0]
                  ],
                  "v": [
                    [-400.009, 126.492],
                    [-404.583, 100.011],
                    [-55.762, -476.338],
                    [-50.226, -496.054]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 70",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 70,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [65.031, -461.225],
                    [604.48, -157.417],
                    [449.164, 101.268]
                  ],
                  "c": false
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 3.566, "ix": 5 },
              "lc": 2,
              "lj": 2,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 71",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 71,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [534.679, 352.77],
                            [414.632, 285.261]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.35, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 1",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 1,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [439.404, 238.914],
                            [556.13, 340.583]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 5.35, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 2",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 2,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "gr",
                  "it": [
                    {
                      "ind": 0,
                      "ty": "sh",
                      "ix": 1,
                      "ks": {
                        "a": 0,
                        "k": {
                          "i": [
                            [0, 0],
                            [0, 0]
                          ],
                          "o": [
                            [0, 0],
                            [0, 0]
                          ],
                          "v": [
                            [425.176, 265.114],
                            [534.679, 352.673]
                          ],
                          "c": false
                        },
                        "ix": 2
                      },
                      "nm": "Path 1",
                      "mn": "ADBE Vector Shape - Group",
                      "hd": false
                    },
                    {
                      "ty": "st",
                      "c": { "a": 0, "k": [0.501960813999, 0.501960813999, 0.501960813999, 1], "ix": 3 },
                      "o": { "a": 0, "k": 100, "ix": 4 },
                      "w": { "a": 0, "k": 3.566, "ix": 5 },
                      "lc": 2,
                      "lj": 2,
                      "bm": 0,
                      "nm": "Stroke 1",
                      "mn": "ADBE Vector Graphic - Stroke",
                      "hd": false
                    },
                    {
                      "ty": "tr",
                      "p": { "a": 0, "k": [0, 0], "ix": 2 },
                      "a": { "a": 0, "k": [0, 0], "ix": 1 },
                      "s": { "a": 0, "k": [100, 100], "ix": 3 },
                      "r": { "a": 0, "k": 0, "ix": 6 },
                      "o": { "a": 0, "k": 100, "ix": 7 },
                      "sk": { "a": 0, "k": 0, "ix": 4 },
                      "sa": { "a": 0, "k": 0, "ix": 5 },
                      "nm": "Transform"
                    }
                  ],
                  "nm": "Group 3",
                  "np": 2,
                  "cix": 2,
                  "bm": 0,
                  "ix": 3,
                  "mn": "ADBE Vector Group",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 3,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [534.679, 352.673],
                        [556.13, 340.583]
                      ],
                      "c": false
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "st",
                  "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 },
                  "o": { "a": 0, "k": 100, "ix": 4 },
                  "w": { "a": 0, "k": 5.35, "ix": 5 },
                  "lc": 2,
                  "lj": 2,
                  "bm": 0,
                  "nm": "Stroke 1",
                  "mn": "ADBE Vector Graphic - Stroke",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [0, 0], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 72",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 72,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 501,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
}
